import {
  GlobalEvents,
  SectionElement,
  Theme,
  defineElement,
  onClick,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __commonJS,
  __decorateClass,
  __publicField,
  __spreadValues,
  __toESM
} from "./chunk-RGTSXKO2.js";

// node_modules/secure-json-parse/index.js
var require_secure_json_parse = __commonJS({
  "node_modules/secure-json-parse/index.js"(exports, module) {
    "use strict";
    var hasBuffer = typeof Buffer !== "undefined";
    var suspectProtoRx = /"(?:_|\\u005[Ff])(?:_|\\u005[Ff])(?:p|\\u0070)(?:r|\\u0072)(?:o|\\u006[Ff])(?:t|\\u0074)(?:o|\\u006[Ff])(?:_|\\u005[Ff])(?:_|\\u005[Ff])"\s*:/;
    var suspectConstructorRx = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/;
    function _parse(text, reviver, options2) {
      if (options2 == null) {
        if (reviver !== null && typeof reviver === "object") {
          options2 = reviver;
          reviver = void 0;
        }
      }
      if (hasBuffer && Buffer.isBuffer(text)) {
        text = text.toString();
      }
      if (text && text.charCodeAt(0) === 65279) {
        text = text.slice(1);
      }
      const obj = JSON.parse(text, reviver);
      if (obj === null || typeof obj !== "object") {
        return obj;
      }
      const protoAction = options2 && options2.protoAction || "error";
      const constructorAction = options2 && options2.constructorAction || "error";
      if (protoAction === "ignore" && constructorAction === "ignore") {
        return obj;
      }
      if (protoAction !== "ignore" && constructorAction !== "ignore") {
        if (suspectProtoRx.test(text) === false && suspectConstructorRx.test(text) === false) {
          return obj;
        }
      } else if (protoAction !== "ignore" && constructorAction === "ignore") {
        if (suspectProtoRx.test(text) === false) {
          return obj;
        }
      } else {
        if (suspectConstructorRx.test(text) === false) {
          return obj;
        }
      }
      return filter(obj, { protoAction, constructorAction, safe: options2 && options2.safe });
    }
    function filter(obj, { protoAction = "error", constructorAction = "error", safe } = {}) {
      let next = [obj];
      while (next.length) {
        const nodes = next;
        next = [];
        for (const node of nodes) {
          if (protoAction !== "ignore" && Object.prototype.hasOwnProperty.call(node, "__proto__")) {
            if (safe === true) {
              return null;
            } else if (protoAction === "error") {
              throw new SyntaxError("Object contains forbidden prototype property");
            }
            delete node.__proto__;
          }
          if (constructorAction !== "ignore" && Object.prototype.hasOwnProperty.call(node, "constructor") && Object.prototype.hasOwnProperty.call(node.constructor, "prototype")) {
            if (safe === true) {
              return null;
            } else if (constructorAction === "error") {
              throw new SyntaxError("Object contains forbidden prototype property");
            }
            delete node.constructor;
          }
          for (const key in node) {
            const value = node[key];
            if (value && typeof value === "object") {
              next.push(value);
            }
          }
        }
      }
      return obj;
    }
    function parse(text, reviver, options2) {
      const stackTraceLimit = Error.stackTraceLimit;
      Error.stackTraceLimit = 0;
      try {
        return _parse(text, reviver, options2);
      } finally {
        Error.stackTraceLimit = stackTraceLimit;
      }
    }
    function safeParse(text, reviver) {
      const stackTraceLimit = Error.stackTraceLimit;
      Error.stackTraceLimit = 0;
      try {
        return _parse(text, reviver, { safe: true });
      } catch (_e) {
        return null;
      } finally {
        Error.stackTraceLimit = stackTraceLimit;
      }
    }
    module.exports = parse;
    module.exports.default = parse;
    module.exports.parse = parse;
    module.exports.safeParse = safeParse;
    module.exports.scan = filter;
  }
});

// node_modules/@ai-sdk/provider/dist/index.mjs
var marker = "vercel.ai.error";
var symbol = Symbol.for(marker);
var _a;
var _AISDKError = class _AISDKError2 extends Error {
  /**
   * Creates an AI SDK Error.
   *
   * @param {Object} params - The parameters for creating the error.
   * @param {string} params.name - The name of the error.
   * @param {string} params.message - The error message.
   * @param {unknown} [params.cause] - The underlying cause of the error.
   */
  constructor({
    name: name14,
    message,
    cause
  }) {
    super(message);
    this[_a] = true;
    this.name = name14;
    this.cause = cause;
  }
  /**
   * Checks if the given error is an AI SDK Error.
   * @param {unknown} error - The error to check.
   * @returns {boolean} True if the error is an AI SDK Error, false otherwise.
   */
  static isInstance(error) {
    return _AISDKError2.hasMarker(error, marker);
  }
  static hasMarker(error, marker15) {
    const markerSymbol = Symbol.for(marker15);
    return error != null && typeof error === "object" && markerSymbol in error && typeof error[markerSymbol] === "boolean" && error[markerSymbol] === true;
  }
};
_a = symbol;
var AISDKError = _AISDKError;
var name = "AI_APICallError";
var marker2 = `vercel.ai.error.${name}`;
var symbol2 = Symbol.for(marker2);
var _a2;
_a2 = symbol2;
var name2 = "AI_EmptyResponseBodyError";
var marker3 = `vercel.ai.error.${name2}`;
var symbol3 = Symbol.for(marker3);
var _a3;
_a3 = symbol3;
function getErrorMessage(error) {
  if (error == null) {
    return "unknown error";
  }
  if (typeof error === "string") {
    return error;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return JSON.stringify(error);
}
var name3 = "AI_InvalidArgumentError";
var marker4 = `vercel.ai.error.${name3}`;
var symbol4 = Symbol.for(marker4);
var _a4;
var InvalidArgumentError = class extends AISDKError {
  constructor({
    message,
    cause,
    argument
  }) {
    super({ name: name3, message, cause });
    this[_a4] = true;
    this.argument = argument;
  }
  static isInstance(error) {
    return AISDKError.hasMarker(error, marker4);
  }
};
_a4 = symbol4;
var name4 = "AI_InvalidPromptError";
var marker5 = `vercel.ai.error.${name4}`;
var symbol5 = Symbol.for(marker5);
var _a5;
_a5 = symbol5;
var name5 = "AI_InvalidResponseDataError";
var marker6 = `vercel.ai.error.${name5}`;
var symbol6 = Symbol.for(marker6);
var _a6;
_a6 = symbol6;
var name6 = "AI_JSONParseError";
var marker7 = `vercel.ai.error.${name6}`;
var symbol7 = Symbol.for(marker7);
var _a7;
var JSONParseError = class extends AISDKError {
  constructor({ text, cause }) {
    super({
      name: name6,
      message: `JSON parsing failed: Text: ${text}.
Error message: ${getErrorMessage(cause)}`,
      cause
    });
    this[_a7] = true;
    this.text = text;
  }
  static isInstance(error) {
    return AISDKError.hasMarker(error, marker7);
  }
};
_a7 = symbol7;
var name7 = "AI_LoadAPIKeyError";
var marker8 = `vercel.ai.error.${name7}`;
var symbol8 = Symbol.for(marker8);
var _a8;
_a8 = symbol8;
var name8 = "AI_LoadSettingError";
var marker9 = `vercel.ai.error.${name8}`;
var symbol9 = Symbol.for(marker9);
var _a9;
_a9 = symbol9;
var name9 = "AI_NoContentGeneratedError";
var marker10 = `vercel.ai.error.${name9}`;
var symbol10 = Symbol.for(marker10);
var _a10;
_a10 = symbol10;
var name10 = "AI_NoSuchModelError";
var marker11 = `vercel.ai.error.${name10}`;
var symbol11 = Symbol.for(marker11);
var _a11;
_a11 = symbol11;
var name11 = "AI_TooManyEmbeddingValuesForCallError";
var marker12 = `vercel.ai.error.${name11}`;
var symbol12 = Symbol.for(marker12);
var _a12;
_a12 = symbol12;
var name12 = "AI_TypeValidationError";
var marker13 = `vercel.ai.error.${name12}`;
var symbol13 = Symbol.for(marker13);
var _a13;
var _TypeValidationError = class _TypeValidationError2 extends AISDKError {
  constructor({ value, cause }) {
    super({
      name: name12,
      message: `Type validation failed: Value: ${JSON.stringify(value)}.
Error message: ${getErrorMessage(cause)}`,
      cause
    });
    this[_a13] = true;
    this.value = value;
  }
  static isInstance(error) {
    return AISDKError.hasMarker(error, marker13);
  }
  /**
   * Wraps an error into a TypeValidationError.
   * If the cause is already a TypeValidationError with the same value, it returns the cause.
   * Otherwise, it creates a new TypeValidationError.
   *
   * @param {Object} params - The parameters for wrapping the error.
   * @param {unknown} params.value - The value that failed validation.
   * @param {unknown} params.cause - The original error or cause of the validation failure.
   * @returns {TypeValidationError} A TypeValidationError instance.
   */
  static wrap({
    value,
    cause
  }) {
    return _TypeValidationError2.isInstance(cause) && cause.value === value ? cause : new _TypeValidationError2({ value, cause });
  }
};
_a13 = symbol13;
var TypeValidationError = _TypeValidationError;
var name13 = "AI_UnsupportedFunctionalityError";
var marker14 = `vercel.ai.error.${name13}`;
var symbol14 = Symbol.for(marker14);
var _a14;
_a14 = symbol14;

// node_modules/nanoid/non-secure/index.js
var customAlphabet = (alphabet, defaultSize = 21) => {
  return (size = defaultSize) => {
    let id = "";
    let i = size | 0;
    while (i--) {
      id += alphabet[Math.random() * alphabet.length | 0];
    }
    return id;
  };
};

// node_modules/@ai-sdk/provider-utils/dist/index.mjs
var import_secure_json_parse = __toESM(require_secure_json_parse(), 1);
var createIdGenerator = ({
  prefix,
  size: defaultSize = 16,
  alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
  separator = "-"
} = {}) => {
  const generator = customAlphabet(alphabet, defaultSize);
  if (prefix == null) {
    return generator;
  }
  if (alphabet.includes(separator)) {
    throw new InvalidArgumentError({
      argument: "separator",
      message: `The separator "${separator}" must not be part of the alphabet "${alphabet}".`
    });
  }
  return (size) => `${prefix}${separator}${generator(size)}`;
};
var generateId = createIdGenerator();
var validatorSymbol = Symbol.for("vercel.ai.validator");
function validator(validate) {
  return { [validatorSymbol]: true, validate };
}
function isValidator(value) {
  return typeof value === "object" && value !== null && validatorSymbol in value && value[validatorSymbol] === true && "validate" in value;
}
function asValidator(value) {
  return isValidator(value) ? value : zodValidator(value);
}
function zodValidator(zodSchema) {
  return validator((value) => {
    const result = zodSchema.safeParse(value);
    return result.success ? { success: true, value: result.data } : { success: false, error: result.error };
  });
}
function safeValidateTypes({
  value,
  schema
}) {
  const validator2 = asValidator(schema);
  try {
    if (validator2.validate == null) {
      return { success: true, value };
    }
    const result = validator2.validate(value);
    if (result.success) {
      return result;
    }
    return {
      success: false,
      error: TypeValidationError.wrap({ value, cause: result.error })
    };
  } catch (error) {
    return {
      success: false,
      error: TypeValidationError.wrap({ value, cause: error })
    };
  }
}
function safeParseJSON({
  text,
  schema
}) {
  try {
    const value = import_secure_json_parse.default.parse(text);
    if (schema == null) {
      return {
        success: true,
        value
      };
    }
    return safeValidateTypes({ value, schema });
  } catch (error) {
    return {
      success: false,
      error: JSONParseError.isInstance(error) ? error : new JSONParseError({ text, cause: error })
    };
  }
}
var { btoa, atob } = globalThis;

// node_modules/zod-to-json-schema/dist/esm/Options.js
var ignoreOverride = Symbol("Let zodToJsonSchema decide on which parser to use");

// node_modules/zod-to-json-schema/dist/esm/parsers/string.js
var ALPHA_NUMERIC = new Set("ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvxyz0123456789");

// node_modules/@ai-sdk/ui-utils/dist/index.mjs
var textStreamPart = {
  code: "0",
  name: "text",
  parse: (value) => {
    if (typeof value !== "string") {
      throw new Error('"text" parts expect a string value.');
    }
    return { type: "text", value };
  }
};
var errorStreamPart = {
  code: "3",
  name: "error",
  parse: (value) => {
    if (typeof value !== "string") {
      throw new Error('"error" parts expect a string value.');
    }
    return { type: "error", value };
  }
};
var assistantMessageStreamPart = {
  code: "4",
  name: "assistant_message",
  parse: (value) => {
    if (value == null || typeof value !== "object" || !("id" in value) || !("role" in value) || !("content" in value) || typeof value.id !== "string" || typeof value.role !== "string" || value.role !== "assistant" || !Array.isArray(value.content) || !value.content.every(
      (item) => item != null && typeof item === "object" && "type" in item && item.type === "text" && "text" in item && item.text != null && typeof item.text === "object" && "value" in item.text && typeof item.text.value === "string"
    )) {
      throw new Error(
        '"assistant_message" parts expect an object with an "id", "role", and "content" property.'
      );
    }
    return {
      type: "assistant_message",
      value
    };
  }
};
var assistantControlDataStreamPart = {
  code: "5",
  name: "assistant_control_data",
  parse: (value) => {
    if (value == null || typeof value !== "object" || !("threadId" in value) || !("messageId" in value) || typeof value.threadId !== "string" || typeof value.messageId !== "string") {
      throw new Error(
        '"assistant_control_data" parts expect an object with a "threadId" and "messageId" property.'
      );
    }
    return {
      type: "assistant_control_data",
      value: {
        threadId: value.threadId,
        messageId: value.messageId
      }
    };
  }
};
var dataMessageStreamPart = {
  code: "6",
  name: "data_message",
  parse: (value) => {
    if (value == null || typeof value !== "object" || !("role" in value) || !("data" in value) || typeof value.role !== "string" || value.role !== "data") {
      throw new Error(
        '"data_message" parts expect an object with a "role" and "data" property.'
      );
    }
    return {
      type: "data_message",
      value
    };
  }
};
var assistantStreamParts = [
  textStreamPart,
  errorStreamPart,
  assistantMessageStreamPart,
  assistantControlDataStreamPart,
  dataMessageStreamPart
];
var assistantStreamPartsByCode = {
  [textStreamPart.code]: textStreamPart,
  [errorStreamPart.code]: errorStreamPart,
  [assistantMessageStreamPart.code]: assistantMessageStreamPart,
  [assistantControlDataStreamPart.code]: assistantControlDataStreamPart,
  [dataMessageStreamPart.code]: dataMessageStreamPart
};
var StreamStringPrefixes = {
  [textStreamPart.name]: textStreamPart.code,
  [errorStreamPart.name]: errorStreamPart.code,
  [assistantMessageStreamPart.name]: assistantMessageStreamPart.code,
  [assistantControlDataStreamPart.name]: assistantControlDataStreamPart.code,
  [dataMessageStreamPart.name]: dataMessageStreamPart.code
};
var validCodes = assistantStreamParts.map((part) => part.code);
function fixJson(input) {
  const stack = ["ROOT"];
  let lastValidIndex = -1;
  let literalStart = null;
  function processValueStart(char, i, swapState) {
    {
      switch (char) {
        case '"': {
          lastValidIndex = i;
          stack.pop();
          stack.push(swapState);
          stack.push("INSIDE_STRING");
          break;
        }
        case "f":
        case "t":
        case "n": {
          lastValidIndex = i;
          literalStart = i;
          stack.pop();
          stack.push(swapState);
          stack.push("INSIDE_LITERAL");
          break;
        }
        case "-": {
          stack.pop();
          stack.push(swapState);
          stack.push("INSIDE_NUMBER");
          break;
        }
        case "0":
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
        case "8":
        case "9": {
          lastValidIndex = i;
          stack.pop();
          stack.push(swapState);
          stack.push("INSIDE_NUMBER");
          break;
        }
        case "{": {
          lastValidIndex = i;
          stack.pop();
          stack.push(swapState);
          stack.push("INSIDE_OBJECT_START");
          break;
        }
        case "[": {
          lastValidIndex = i;
          stack.pop();
          stack.push(swapState);
          stack.push("INSIDE_ARRAY_START");
          break;
        }
      }
    }
  }
  function processAfterObjectValue(char, i) {
    switch (char) {
      case ",": {
        stack.pop();
        stack.push("INSIDE_OBJECT_AFTER_COMMA");
        break;
      }
      case "}": {
        lastValidIndex = i;
        stack.pop();
        break;
      }
    }
  }
  function processAfterArrayValue(char, i) {
    switch (char) {
      case ",": {
        stack.pop();
        stack.push("INSIDE_ARRAY_AFTER_COMMA");
        break;
      }
      case "]": {
        lastValidIndex = i;
        stack.pop();
        break;
      }
    }
  }
  for (let i = 0; i < input.length; i++) {
    const char = input[i];
    const currentState = stack[stack.length - 1];
    switch (currentState) {
      case "ROOT":
        processValueStart(char, i, "FINISH");
        break;
      case "INSIDE_OBJECT_START": {
        switch (char) {
          case '"': {
            stack.pop();
            stack.push("INSIDE_OBJECT_KEY");
            break;
          }
          case "}": {
            lastValidIndex = i;
            stack.pop();
            break;
          }
        }
        break;
      }
      case "INSIDE_OBJECT_AFTER_COMMA": {
        switch (char) {
          case '"': {
            stack.pop();
            stack.push("INSIDE_OBJECT_KEY");
            break;
          }
        }
        break;
      }
      case "INSIDE_OBJECT_KEY": {
        switch (char) {
          case '"': {
            stack.pop();
            stack.push("INSIDE_OBJECT_AFTER_KEY");
            break;
          }
        }
        break;
      }
      case "INSIDE_OBJECT_AFTER_KEY": {
        switch (char) {
          case ":": {
            stack.pop();
            stack.push("INSIDE_OBJECT_BEFORE_VALUE");
            break;
          }
        }
        break;
      }
      case "INSIDE_OBJECT_BEFORE_VALUE": {
        processValueStart(char, i, "INSIDE_OBJECT_AFTER_VALUE");
        break;
      }
      case "INSIDE_OBJECT_AFTER_VALUE": {
        processAfterObjectValue(char, i);
        break;
      }
      case "INSIDE_STRING": {
        switch (char) {
          case '"': {
            stack.pop();
            lastValidIndex = i;
            break;
          }
          case "\\": {
            stack.push("INSIDE_STRING_ESCAPE");
            break;
          }
          default: {
            lastValidIndex = i;
          }
        }
        break;
      }
      case "INSIDE_ARRAY_START": {
        switch (char) {
          case "]": {
            lastValidIndex = i;
            stack.pop();
            break;
          }
          default: {
            lastValidIndex = i;
            processValueStart(char, i, "INSIDE_ARRAY_AFTER_VALUE");
            break;
          }
        }
        break;
      }
      case "INSIDE_ARRAY_AFTER_VALUE": {
        switch (char) {
          case ",": {
            stack.pop();
            stack.push("INSIDE_ARRAY_AFTER_COMMA");
            break;
          }
          case "]": {
            lastValidIndex = i;
            stack.pop();
            break;
          }
          default: {
            lastValidIndex = i;
            break;
          }
        }
        break;
      }
      case "INSIDE_ARRAY_AFTER_COMMA": {
        processValueStart(char, i, "INSIDE_ARRAY_AFTER_VALUE");
        break;
      }
      case "INSIDE_STRING_ESCAPE": {
        stack.pop();
        lastValidIndex = i;
        break;
      }
      case "INSIDE_NUMBER": {
        switch (char) {
          case "0":
          case "1":
          case "2":
          case "3":
          case "4":
          case "5":
          case "6":
          case "7":
          case "8":
          case "9": {
            lastValidIndex = i;
            break;
          }
          case "e":
          case "E":
          case "-":
          case ".": {
            break;
          }
          case ",": {
            stack.pop();
            if (stack[stack.length - 1] === "INSIDE_ARRAY_AFTER_VALUE") {
              processAfterArrayValue(char, i);
            }
            if (stack[stack.length - 1] === "INSIDE_OBJECT_AFTER_VALUE") {
              processAfterObjectValue(char, i);
            }
            break;
          }
          case "}": {
            stack.pop();
            if (stack[stack.length - 1] === "INSIDE_OBJECT_AFTER_VALUE") {
              processAfterObjectValue(char, i);
            }
            break;
          }
          case "]": {
            stack.pop();
            if (stack[stack.length - 1] === "INSIDE_ARRAY_AFTER_VALUE") {
              processAfterArrayValue(char, i);
            }
            break;
          }
          default: {
            stack.pop();
            break;
          }
        }
        break;
      }
      case "INSIDE_LITERAL": {
        const partialLiteral = input.substring(literalStart, i + 1);
        if (!"false".startsWith(partialLiteral) && !"true".startsWith(partialLiteral) && !"null".startsWith(partialLiteral)) {
          stack.pop();
          if (stack[stack.length - 1] === "INSIDE_OBJECT_AFTER_VALUE") {
            processAfterObjectValue(char, i);
          } else if (stack[stack.length - 1] === "INSIDE_ARRAY_AFTER_VALUE") {
            processAfterArrayValue(char, i);
          }
        } else {
          lastValidIndex = i;
        }
        break;
      }
    }
  }
  let result = input.slice(0, lastValidIndex + 1);
  for (let i = stack.length - 1; i >= 0; i--) {
    const state = stack[i];
    switch (state) {
      case "INSIDE_STRING": {
        result += '"';
        break;
      }
      case "INSIDE_OBJECT_KEY":
      case "INSIDE_OBJECT_AFTER_KEY":
      case "INSIDE_OBJECT_AFTER_COMMA":
      case "INSIDE_OBJECT_START":
      case "INSIDE_OBJECT_BEFORE_VALUE":
      case "INSIDE_OBJECT_AFTER_VALUE": {
        result += "}";
        break;
      }
      case "INSIDE_ARRAY_START":
      case "INSIDE_ARRAY_AFTER_COMMA":
      case "INSIDE_ARRAY_AFTER_VALUE": {
        result += "]";
        break;
      }
      case "INSIDE_LITERAL": {
        const partialLiteral = input.substring(literalStart, input.length);
        if ("true".startsWith(partialLiteral)) {
          result += "true".slice(partialLiteral.length);
        } else if ("false".startsWith(partialLiteral)) {
          result += "false".slice(partialLiteral.length);
        } else if ("null".startsWith(partialLiteral)) {
          result += "null".slice(partialLiteral.length);
        }
      }
    }
  }
  return result;
}
function parsePartialJson(jsonText) {
  if (jsonText === void 0) {
    return { value: void 0, state: "undefined-input" };
  }
  let result = safeParseJSON({ text: jsonText });
  if (result.success) {
    return { value: result.value, state: "successful-parse" };
  }
  result = safeParseJSON({ text: fixJson(jsonText) });
  if (result.success) {
    return { value: result.value, state: "repaired-parse" };
  }
  return { value: void 0, state: "failed-parse" };
}
var textStreamPart2 = {
  code: "0",
  name: "text",
  parse: (value) => {
    if (typeof value !== "string") {
      throw new Error('"text" parts expect a string value.');
    }
    return { type: "text", value };
  }
};
var dataStreamPart = {
  code: "2",
  name: "data",
  parse: (value) => {
    if (!Array.isArray(value)) {
      throw new Error('"data" parts expect an array value.');
    }
    return { type: "data", value };
  }
};
var errorStreamPart2 = {
  code: "3",
  name: "error",
  parse: (value) => {
    if (typeof value !== "string") {
      throw new Error('"error" parts expect a string value.');
    }
    return { type: "error", value };
  }
};
var messageAnnotationsStreamPart = {
  code: "8",
  name: "message_annotations",
  parse: (value) => {
    if (!Array.isArray(value)) {
      throw new Error('"message_annotations" parts expect an array value.');
    }
    return { type: "message_annotations", value };
  }
};
var toolCallStreamPart = {
  code: "9",
  name: "tool_call",
  parse: (value) => {
    if (value == null || typeof value !== "object" || !("toolCallId" in value) || typeof value.toolCallId !== "string" || !("toolName" in value) || typeof value.toolName !== "string" || !("args" in value) || typeof value.args !== "object") {
      throw new Error(
        '"tool_call" parts expect an object with a "toolCallId", "toolName", and "args" property.'
      );
    }
    return {
      type: "tool_call",
      value
    };
  }
};
var toolResultStreamPart = {
  code: "a",
  name: "tool_result",
  parse: (value) => {
    if (value == null || typeof value !== "object" || !("toolCallId" in value) || typeof value.toolCallId !== "string" || !("result" in value)) {
      throw new Error(
        '"tool_result" parts expect an object with a "toolCallId" and a "result" property.'
      );
    }
    return {
      type: "tool_result",
      value
    };
  }
};
var toolCallStreamingStartStreamPart = {
  code: "b",
  name: "tool_call_streaming_start",
  parse: (value) => {
    if (value == null || typeof value !== "object" || !("toolCallId" in value) || typeof value.toolCallId !== "string" || !("toolName" in value) || typeof value.toolName !== "string") {
      throw new Error(
        '"tool_call_streaming_start" parts expect an object with a "toolCallId" and "toolName" property.'
      );
    }
    return {
      type: "tool_call_streaming_start",
      value
    };
  }
};
var toolCallDeltaStreamPart = {
  code: "c",
  name: "tool_call_delta",
  parse: (value) => {
    if (value == null || typeof value !== "object" || !("toolCallId" in value) || typeof value.toolCallId !== "string" || !("argsTextDelta" in value) || typeof value.argsTextDelta !== "string") {
      throw new Error(
        '"tool_call_delta" parts expect an object with a "toolCallId" and "argsTextDelta" property.'
      );
    }
    return {
      type: "tool_call_delta",
      value
    };
  }
};
var finishMessageStreamPart = {
  code: "d",
  name: "finish_message",
  parse: (value) => {
    if (value == null || typeof value !== "object" || !("finishReason" in value) || typeof value.finishReason !== "string") {
      throw new Error(
        '"finish_message" parts expect an object with a "finishReason" property.'
      );
    }
    const result = {
      finishReason: value.finishReason
    };
    if ("usage" in value && value.usage != null && typeof value.usage === "object" && "promptTokens" in value.usage && "completionTokens" in value.usage) {
      result.usage = {
        promptTokens: typeof value.usage.promptTokens === "number" ? value.usage.promptTokens : Number.NaN,
        completionTokens: typeof value.usage.completionTokens === "number" ? value.usage.completionTokens : Number.NaN
      };
    }
    return {
      type: "finish_message",
      value: result
    };
  }
};
var finishStepStreamPart = {
  code: "e",
  name: "finish_step",
  parse: (value) => {
    if (value == null || typeof value !== "object" || !("finishReason" in value) || typeof value.finishReason !== "string") {
      throw new Error(
        '"finish_step" parts expect an object with a "finishReason" property.'
      );
    }
    const result = {
      finishReason: value.finishReason,
      isContinued: false
    };
    if ("usage" in value && value.usage != null && typeof value.usage === "object" && "promptTokens" in value.usage && "completionTokens" in value.usage) {
      result.usage = {
        promptTokens: typeof value.usage.promptTokens === "number" ? value.usage.promptTokens : Number.NaN,
        completionTokens: typeof value.usage.completionTokens === "number" ? value.usage.completionTokens : Number.NaN
      };
    }
    if ("isContinued" in value && typeof value.isContinued === "boolean") {
      result.isContinued = value.isContinued;
    }
    return {
      type: "finish_step",
      value: result
    };
  }
};
var dataStreamParts = [
  textStreamPart2,
  dataStreamPart,
  errorStreamPart2,
  messageAnnotationsStreamPart,
  toolCallStreamPart,
  toolResultStreamPart,
  toolCallStreamingStartStreamPart,
  toolCallDeltaStreamPart,
  finishMessageStreamPart,
  finishStepStreamPart
];
var dataStreamPartsByCode = {
  [textStreamPart2.code]: textStreamPart2,
  [dataStreamPart.code]: dataStreamPart,
  [errorStreamPart2.code]: errorStreamPart2,
  [messageAnnotationsStreamPart.code]: messageAnnotationsStreamPart,
  [toolCallStreamPart.code]: toolCallStreamPart,
  [toolResultStreamPart.code]: toolResultStreamPart,
  [toolCallStreamingStartStreamPart.code]: toolCallStreamingStartStreamPart,
  [toolCallDeltaStreamPart.code]: toolCallDeltaStreamPart,
  [finishMessageStreamPart.code]: finishMessageStreamPart,
  [finishStepStreamPart.code]: finishStepStreamPart
};
var DataStreamStringPrefixes = {
  [textStreamPart2.name]: textStreamPart2.code,
  [dataStreamPart.name]: dataStreamPart.code,
  [errorStreamPart2.name]: errorStreamPart2.code,
  [messageAnnotationsStreamPart.name]: messageAnnotationsStreamPart.code,
  [toolCallStreamPart.name]: toolCallStreamPart.code,
  [toolResultStreamPart.name]: toolResultStreamPart.code,
  [toolCallStreamingStartStreamPart.name]: toolCallStreamingStartStreamPart.code,
  [toolCallDeltaStreamPart.name]: toolCallDeltaStreamPart.code,
  [finishMessageStreamPart.name]: finishMessageStreamPart.code,
  [finishStepStreamPart.name]: finishStepStreamPart.code
};
var validCodes2 = dataStreamParts.map((part) => part.code);
var parseDataStreamPart = (line) => {
  const firstSeparatorIndex = line.indexOf(":");
  if (firstSeparatorIndex === -1) {
    throw new Error("Failed to parse stream string. No separator found.");
  }
  const prefix = line.slice(0, firstSeparatorIndex);
  if (!validCodes2.includes(prefix)) {
    throw new Error(`Failed to parse stream string. Invalid code ${prefix}.`);
  }
  const code = prefix;
  const textValue = line.slice(firstSeparatorIndex + 1);
  const jsonValue = JSON.parse(textValue);
  return dataStreamPartsByCode[code].parse(jsonValue);
};
var NEWLINE = "\n".charCodeAt(0);
function concatChunks(chunks, totalLength) {
  const concatenatedChunks = new Uint8Array(totalLength);
  let offset = 0;
  for (const chunk of chunks) {
    concatenatedChunks.set(chunk, offset);
    offset += chunk.length;
  }
  chunks.length = 0;
  return concatenatedChunks;
}
async function processDataStream({
  stream,
  onTextPart,
  onDataPart,
  onErrorPart,
  onToolCallStreamingStartPart,
  onToolCallDeltaPart,
  onToolCallPart,
  onToolResultPart,
  onMessageAnnotationsPart,
  onFinishMessagePart,
  onFinishStepPart
}) {
  const reader = stream.getReader();
  const decoder = new TextDecoder();
  const chunks = [];
  let totalLength = 0;
  while (true) {
    const { value } = await reader.read();
    if (value) {
      chunks.push(value);
      totalLength += value.length;
      if (value[value.length - 1] !== NEWLINE) {
        continue;
      }
    }
    if (chunks.length === 0) {
      break;
    }
    const concatenatedChunks = concatChunks(chunks, totalLength);
    totalLength = 0;
    const streamParts = decoder.decode(concatenatedChunks, { stream: true }).split("\n").filter((line) => line !== "").map(parseDataStreamPart);
    for (const { type, value: value2 } of streamParts) {
      switch (type) {
        case "text":
          await (onTextPart == null ? void 0 : onTextPart(value2));
          break;
        case "data":
          await (onDataPart == null ? void 0 : onDataPart(value2));
          break;
        case "error":
          await (onErrorPart == null ? void 0 : onErrorPart(value2));
          break;
        case "message_annotations":
          await (onMessageAnnotationsPart == null ? void 0 : onMessageAnnotationsPart(value2));
          break;
        case "tool_call_streaming_start":
          await (onToolCallStreamingStartPart == null ? void 0 : onToolCallStreamingStartPart(value2));
          break;
        case "tool_call_delta":
          await (onToolCallDeltaPart == null ? void 0 : onToolCallDeltaPart(value2));
          break;
        case "tool_call":
          await (onToolCallPart == null ? void 0 : onToolCallPart(value2));
          break;
        case "tool_result":
          await (onToolResultPart == null ? void 0 : onToolResultPart(value2));
          break;
        case "finish_message":
          await (onFinishMessagePart == null ? void 0 : onFinishMessagePart(value2));
          break;
        case "finish_step":
          await (onFinishStepPart == null ? void 0 : onFinishStepPart(value2));
          break;
        default: {
          const exhaustiveCheck = type;
          throw new Error(`Unknown stream part type: ${exhaustiveCheck}`);
        }
      }
    }
  }
}
function calculateLanguageModelUsage({
  promptTokens,
  completionTokens
}) {
  return {
    promptTokens,
    completionTokens,
    totalTokens: promptTokens + completionTokens
  };
}
async function processChatResponse({
  stream,
  update,
  onToolCall,
  onFinish,
  generateId: generateId2 = generateId,
  getCurrentDate = () => /* @__PURE__ */ new Date()
}) {
  const createdAt = getCurrentDate();
  let currentMessage = void 0;
  let createNewMessage = true;
  const previousMessages = [];
  const data = [];
  let messageAnnotations = void 0;
  const partialToolCalls = {};
  let usage = {
    completionTokens: NaN,
    promptTokens: NaN,
    totalTokens: NaN
  };
  let finishReason = "unknown";
  function execUpdate() {
    const copiedData = [...data];
    if (currentMessage == null) {
      update(previousMessages, copiedData);
      return;
    }
    if (messageAnnotations == null ? void 0 : messageAnnotations.length) {
      currentMessage.annotations = messageAnnotations;
    }
    const copiedMessage = {
      // deep copy the message to ensure that deep changes (msg attachments) are updated
      // with SolidJS. SolidJS uses referential integration of sub-objects to detect changes.
      ...JSON.parse(JSON.stringify(currentMessage)),
      // add a revision id to ensure that the message is updated with SWR. SWR uses a
      // hashing approach by default to detect changes, but it only works for shallow
      // changes. This is why we need to add a revision id to ensure that the message
      // is updated with SWR (without it, the changes get stuck in SWR and are not
      // forwarded to rendering):
      revisionId: generateId2(),
      // Fill in createdAt to retain Date object (lost in JSON.parse):
      createdAt: currentMessage.createdAt
    };
    update([...previousMessages, copiedMessage], copiedData);
  }
  function getMessage() {
    if (createNewMessage || currentMessage == null) {
      if (currentMessage != null) {
        previousMessages.push(currentMessage);
      }
      createNewMessage = false;
      currentMessage = {
        id: generateId2(),
        role: "assistant",
        content: "",
        createdAt
      };
    }
    return currentMessage;
  }
  await processDataStream({
    stream,
    onTextPart(value) {
      const activeMessage = getMessage();
      currentMessage = {
        ...activeMessage,
        content: activeMessage.content + value
      };
      execUpdate();
    },
    onToolCallStreamingStartPart(value) {
      const activeMessage = getMessage();
      if (activeMessage.toolInvocations == null) {
        activeMessage.toolInvocations = [];
      }
      partialToolCalls[value.toolCallId] = {
        text: "",
        toolName: value.toolName,
        index: activeMessage.toolInvocations.length
      };
      activeMessage.toolInvocations.push({
        state: "partial-call",
        toolCallId: value.toolCallId,
        toolName: value.toolName,
        args: void 0
      });
      execUpdate();
    },
    onToolCallDeltaPart(value) {
      const activeMessage = getMessage();
      const partialToolCall = partialToolCalls[value.toolCallId];
      partialToolCall.text += value.argsTextDelta;
      const { value: partialArgs } = parsePartialJson(partialToolCall.text);
      activeMessage.toolInvocations[partialToolCall.index] = {
        state: "partial-call",
        toolCallId: value.toolCallId,
        toolName: partialToolCall.toolName,
        args: partialArgs
      };
      execUpdate();
    },
    async onToolCallPart(value) {
      const activeMessage = getMessage();
      if (partialToolCalls[value.toolCallId] != null) {
        activeMessage.toolInvocations[partialToolCalls[value.toolCallId].index] = { state: "call", ...value };
      } else {
        if (activeMessage.toolInvocations == null) {
          activeMessage.toolInvocations = [];
        }
        activeMessage.toolInvocations.push({
          state: "call",
          ...value
        });
      }
      if (onToolCall) {
        const result = await onToolCall({ toolCall: value });
        if (result != null) {
          activeMessage.toolInvocations[activeMessage.toolInvocations.length - 1] = { state: "result", ...value, result };
        }
      }
      execUpdate();
    },
    onToolResultPart(value) {
      const activeMessage = getMessage();
      const toolInvocations = activeMessage.toolInvocations;
      if (toolInvocations == null) {
        throw new Error("tool_result must be preceded by a tool_call");
      }
      const toolInvocationIndex = toolInvocations.findIndex(
        (invocation) => invocation.toolCallId === value.toolCallId
      );
      if (toolInvocationIndex === -1) {
        throw new Error(
          "tool_result must be preceded by a tool_call with the same toolCallId"
        );
      }
      toolInvocations[toolInvocationIndex] = {
        ...toolInvocations[toolInvocationIndex],
        state: "result",
        ...value
      };
      execUpdate();
    },
    onDataPart(value) {
      data.push(...value);
      execUpdate();
    },
    onMessageAnnotationsPart(value) {
      if (messageAnnotations == null) {
        messageAnnotations = [...value];
      } else {
        messageAnnotations.push(...value);
      }
      execUpdate();
    },
    onFinishStepPart(value) {
      createNewMessage = !value.isContinued;
    },
    onFinishMessagePart(value) {
      finishReason = value.finishReason;
      if (value.usage != null) {
        usage = calculateLanguageModelUsage(value.usage);
      }
    },
    onErrorPart(error) {
      throw new Error(error);
    }
  });
  onFinish == null ? void 0 : onFinish({ message: currentMessage, finishReason, usage });
}
async function processTextStream({
  stream,
  onTextPart
}) {
  const reader = stream.pipeThrough(new TextDecoderStream()).getReader();
  while (true) {
    const { done, value } = await reader.read();
    if (done) {
      break;
    }
    await onTextPart(value);
  }
}
var getOriginalFetch = () => fetch;
async function callChatApi({
  api,
  body,
  streamProtocol = "data",
  credentials,
  headers,
  abortController,
  restoreMessagesOnFailure,
  onResponse,
  onUpdate,
  onFinish,
  onToolCall,
  generateId: generateId2,
  fetch: fetch2 = getOriginalFetch()
}) {
  var _a15, _b;
  const response = await fetch2(api, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
      ...headers
    },
    signal: (_a15 = abortController == null ? void 0 : abortController()) == null ? void 0 : _a15.signal,
    credentials
  }).catch((err) => {
    restoreMessagesOnFailure();
    throw err;
  });
  if (onResponse) {
    try {
      await onResponse(response);
    } catch (err) {
      throw err;
    }
  }
  if (!response.ok) {
    restoreMessagesOnFailure();
    throw new Error(
      (_b = await response.text()) != null ? _b : "Failed to fetch the chat response."
    );
  }
  if (!response.body) {
    throw new Error("The response body is empty.");
  }
  switch (streamProtocol) {
    case "text": {
      const resultMessage = {
        id: generateId2(),
        createdAt: /* @__PURE__ */ new Date(),
        role: "assistant",
        content: ""
      };
      await processTextStream({
        stream: response.body,
        onTextPart: (chunk) => {
          resultMessage.content += chunk;
          onUpdate([{ ...resultMessage }], []);
        }
      });
      onFinish == null ? void 0 : onFinish(resultMessage, {
        usage: { completionTokens: NaN, promptTokens: NaN, totalTokens: NaN },
        finishReason: "unknown"
      });
      return;
    }
    case "data": {
      await processChatResponse({
        stream: response.body,
        update: onUpdate,
        onToolCall,
        onFinish({ message, finishReason, usage }) {
          if (onFinish && message != null) {
            onFinish(message, { usage, finishReason });
          }
        },
        generateId: generateId2
      });
      return;
    }
    default: {
      const exhaustiveCheck = streamProtocol;
      throw new Error(`Unknown stream protocol: ${exhaustiveCheck}`);
    }
  }
}
var NEWLINE2 = "\n".charCodeAt(0);
var schemaSymbol = Symbol.for("vercel.ai.schema");

// src/shared/Chat.ts
var Chat = class {
  constructor(strings = {
    tool_invocation_add_to_cart: "Bernd hat das gew\xFCnschte Produkt dem Warenkorb hinzugef\xFCgt.",
    tool_invocation_get_products_by_collection: "Bernd schaut sich nach Produkten um.",
    tool_invocation_get_products: "Bernd schaut sich nach Produkten um.",
    tool_invocation_get_product_details: "Bernd schaut sich die Details des gew\xFCnschten Produktes an.",
    tool_invocation_go_to_checkout: "Bernd leitet Sie zur Kasse weiter.",
    first_message: `Guten Tag!
 \u{1F44B} Ich bin Bernd, Ihr Produktberater bei Schleiftitan.de. Wie kann ich Ihnen heute helfen? Wenn Sie Fragen zu Schleifmitteln, Werkzeugen oder anderen Produkten haben, stehe ich Ihnen gerne zur Verf\xFCgung.`
  }) {
    this.maxMessagesToKeep = 30;
    this.eventListeners = { proposals: { show: [] }, chat: { change: [] } };
    this.cache = /* @__PURE__ */ new Map();
    this.currentFetches = /* @__PURE__ */ new Map();
    this.strings = strings;
  }
  get currentChatId() {
    var _a15;
    return (_a15 = localStorage.getItem("bb-chat-current-chat-id")) != null ? _a15 : "";
  }
  set currentChatId(id) {
    localStorage.setItem("bb-chat-current-chat-id", id);
  }
  get chatInstances() {
    var _a15;
    return JSON.parse((_a15 = localStorage.getItem("bb-chat-messages")) != null ? _a15 : "[]");
  }
  set chatInstances(instances) {
    localStorage.setItem("bb-chat-messages", JSON.stringify(instances));
  }
  get currentMessages() {
    var _a15, _b;
    return (_b = (_a15 = this.chatInstances.find((instance) => instance.id === this.currentChatId)) == null ? void 0 : _a15.messages) != null ? _b : [];
  }
  set currentMessages(messages) {
    const chatInstances = this.chatInstances.filter((chatInstance) => chatInstance.id !== this.currentChatId);
    this.chatInstances = [...chatInstances, { id: this.currentChatId, messages, proposals: this.currentProposals }];
  }
  get currentProposals() {
    var _a15, _b;
    return (_b = (_a15 = this.chatInstances.find((instance) => instance.id === this.currentChatId)) == null ? void 0 : _a15.proposals) != null ? _b : [];
  }
  set currentProposals(proposals) {
    const chatInstances = this.chatInstances.filter((chatInstance) => chatInstance.id !== this.currentChatId);
    this.chatInstances = [...chatInstances, { id: this.currentChatId, messages: this.currentMessages, proposals }];
  }
  appendChatMessage(...messages) {
    const newMessages = messages.filter((message) => !this.currentMessages.find((currentMessage) => currentMessage.id === message.id));
    const updatedMessages = this.currentMessages.map((message) => {
      var _a15;
      return (_a15 = messages.find((newMessage) => newMessage.id === message.id)) != null ? _a15 : message;
    });
    this.currentMessages = [...updatedMessages, ...newMessages];
  }
  get chatInstancePreviews() {
    const chatInstances = this.chatInstances;
    const chatInstancesWithParsedMessages = chatInstances.filter((chatInstances2) => chatInstances2.messages.length > 0).map((chatInstance) => {
      return {
        id: chatInstance.id,
        lastMessage: this.parseUiMessage(chatInstance.messages[chatInstance.messages.length - 1])[0]
      };
    });
    return chatInstancesWithParsedMessages;
  }
  getOrFetchProduct(handle) {
    if (this.cache.has(handle)) {
      return this.cache.get(handle);
    }
    if (this.currentFetches.has(handle)) {
      return;
    }
    const fetchPromise = this.fetchProductByHandle(handle).then((product) => {
      this.cache.set(handle, product);
      this.currentFetches.delete(handle);
      this.changeMessages();
      return product;
    });
    this.currentFetches.set(handle, fetchPromise);
  }
  fetchProductByHandle(handle) {
    return __async(this, null, function* () {
      var _a15, _b, _c;
      const product = yield fetch(`${(_c = (_b = (_a15 = window == null ? void 0 : window.Shopify) == null ? void 0 : _a15.routes) == null ? void 0 : _b.root) != null ? _c : "/"}products/${handle}?view=ajax`).then((response) => response.json());
      return product;
    });
  }
  clearMessages() {
    this.emit("chat", "change", []);
  }
  exitChat() {
    this.clearMessages();
    this.currentChatId = "";
  }
  changeMessages() {
    this.emit("chat", "change", this.parseUiMessages(this.currentMessages));
  }
  changeProposals() {
    this.emit("proposals", "show", this.currentProposals);
  }
  parseUiMessage(message) {
    var _a15;
    const id = message.id;
    const timestamp = message.createdAt !== void 0 ? new Date(message.createdAt).getTime() : Date.now();
    if (message.role === "user") {
      return [
        {
          id,
          text: message.content,
          type: "text",
          sender: "user",
          timestamp
        }
      ];
    }
    if (message.role === "assistant") {
      const messageString = message.content;
      const handleRegex = /\$handle:([a-zA-Z0-9-]+)/g;
      const completeHandleRegex = /\$handle:([a-zA-Z0-9-]+)(?=[\s\.,!?])/g;
      const completeHandleRegexWithoutCapture = /\$handle:[a-zA-Z0-9-]+(?=[\s\.,!?])/g;
      const splitMessages = messageString.split(completeHandleRegexWithoutCapture).filter((part) => part !== "" && part !== " ");
      const handleMatches = Array.from(messageString.matchAll(completeHandleRegex));
      const messages = [];
      if (message.toolInvocations != null && ((_a15 = message.toolInvocations) == null ? void 0 : _a15.length) > 0) {
        message.toolInvocations.forEach((toolInvocation) => {
          messages.push({
            id: message.id + "_tool_" + toolInvocation.toolName,
            text: this.mapToolInvocation(toolInvocation.toolName),
            type: "text",
            sender: "tool",
            timestamp
          });
        });
      }
      for (let i = 0; i < splitMessages.length; i++) {
        const messagePart = splitMessages[i];
        messages.push({
          id: message.id + "_" + i,
          text: messagePart.replace(handleRegex, ""),
          type: "text",
          sender: "assistant",
          timestamp
        });
        if (handleMatches[i] != null) {
          const product = this.getOrFetchProduct(handleMatches[i][1]);
          messages.push({
            id: message.id + "_p_" + i,
            type: "product",
            sender: "assistant",
            handle: handleMatches[i][1],
            title: product == null ? void 0 : product.title,
            imageSrc: product == null ? void 0 : product.image,
            priceExclVat: product == null ? void 0 : product.price,
            priceInclVat: product == null ? void 0 : product.price_with_tax,
            priceVaries: product == null ? void 0 : product.price_varies,
            timestamp
          });
        }
      }
      return messages;
    }
    return [];
  }
  parseUiMessages(messages) {
    const parsedMessages = messages.map((message) => this.parseUiMessage(message)).flat();
    return parsedMessages.filter((message) => message !== void 0);
  }
  mapToolInvocation(toolName) {
    switch (toolName) {
      case "addToCart":
        return this.strings.tool_invocation_add_to_cart;
      case "getProductsByCollection":
        return this.strings.tool_invocation_get_products_by_collection;
      case "getProducts":
        return this.strings.tool_invocation_get_products;
      case "getProductDetails":
        return this.strings.tool_invocation_get_product_details;
      case "goToCheckout":
        return this.strings.tool_invocation_go_to_checkout;
      default:
        return toolName;
    }
  }
  removeChat(id) {
    this.chatInstances = this.chatInstances.filter((chatInstance) => chatInstance.id !== id);
  }
  loadAndSetCurrentChat(id) {
    this.clearMessages();
    this.currentChatId = id;
    this.changeMessages();
    this.changeProposals();
  }
  startNewChat(initialProposals) {
    this.clearMessages();
    this.currentChatId = generateId();
    this.appendChatMessage({
      content: this.strings.first_message,
      id: generateId(),
      role: "assistant"
    });
    if (initialProposals != null && initialProposals.length > 0) {
      this.currentProposals = initialProposals;
    }
    this.changeMessages();
    this.changeProposals();
  }
  handleSendMessage(message) {
    return __async(this, null, function* () {
      var _a15, _b, _c;
      const self = this;
      const generatedMessageId = generateId();
      const messageToSend = {
        content: message,
        id: generatedMessageId,
        role: "user"
      };
      this.appendChatMessage(messageToSend);
      this.changeMessages();
      yield callChatApi({
        api: "https://schleiftitan-ai.pages.dev/api/chat",
        body: {
          messages: this.currentMessages
        },
        streamProtocol: "data",
        credentials: "omit",
        headers: __spreadValues({
          "X-Locale": [(_a15 = window.Shopify) == null ? void 0 : _a15.locale, (_b = window.Shopify) == null ? void 0 : _b.country].join("-")
        }, localStorage.getItem("bb-chat-model") ? { "X-Model": (_c = localStorage.getItem("bb-chat-model")) != null ? _c : "" } : {}),
        abortController: () => {
          return new AbortController();
        },
        restoreMessagesOnFailure() {
        },
        onResponse(response) {
        },
        onUpdate: (messages, data) => {
          if (data && data.length > 0) {
            for (const payload of data) {
              if (payload && typeof payload === "object" && "type" in payload) {
                const typedPayload = payload;
                if (typedPayload.type === "answerProposals") {
                  self.currentProposals = typedPayload.data;
                  this.changeProposals();
                }
              }
            }
          }
          this.appendChatMessage(...messages);
          this.changeMessages();
        },
        onFinish: (message2, options2) => {
        },
        generateId,
        onToolCall(_0) {
          return __async(this, arguments, function* ({ toolCall }) {
            switch (toolCall.toolName) {
              case "addToCart":
                const args = toolCall.args;
                const variantId = args.variantId;
                const quantity = args.quantity;
                const item = {
                  id: variantId,
                  quantity: quantity != null ? quantity : 1,
                  properties: {
                    _origin: "chat-bot"
                  }
                };
                yield Theme.Cart.addItem(item);
                Theme.Cart.emit("updated");
                GlobalEvents.emit("cart:open");
                break;
              case "goToCheckout":
                window.open("/checkout", "checkout", "width=500,height=700");
                break;
            }
          });
        },
        fetch
      });
    });
  }
  emit(event, type, message) {
    if (!this.eventListeners[event])
      return;
    this.eventListeners[event][type].forEach((listener) => listener(message));
  }
  onChat(type, callback) {
    this.eventListeners.chat[type].push(callback);
  }
  onProposals(type, callback) {
    this.eventListeners.proposals.show.push(callback);
  }
};

// src/shared/consts.ts
var ICON_SVS_HELMET = (
  /*HTML*/
  `
<svg data-message-bot-icon style="width:24px;height:24px" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="20" cy="20" r="20" fill="#1F72EE"/>
  <path d="M27.8901 29.3632L26.5752 25.0654L26.5648 25.0317L26.5391 24.9484L26.2362 23.9576L25.6346 21.9918C25.6318 21.9719 25.6256 21.9526 25.6173 21.9347C25.5861 21.8693 25.523 21.8232 25.4474 21.8156C25.4398 21.8149 25.4329 21.8135 25.4252 21.8135C25.4176 21.8135 25.4107 21.8149 25.4038 21.8156H24.4479C23.9683 21.8156 23.5787 21.4293 23.5787 20.9522C23.5787 20.475 23.9676 20.0887 24.4479 20.0887H25.9714C26.0421 20.0991 26.1004 20.1431 26.1309 20.2044L26.1503 20.2678L26.7498 22.2549C26.7526 22.2755 26.7588 22.2948 26.7672 22.3134C26.7755 22.3306 26.7852 22.3471 26.7977 22.3616C26.8101 22.3726 26.8233 22.3836 26.8358 22.3946C26.8399 22.3981 26.8434 22.4015 26.8476 22.405C26.8593 22.4125 26.8718 22.4181 26.885 22.4229L27.5795 22.8208L27.61 22.8387L27.6488 22.8608C27.653 22.8621 27.6579 22.8628 27.662 22.8635C27.678 22.8669 27.6939 22.8697 27.7112 22.8697C27.8214 22.8697 27.9115 22.7857 27.9213 22.6783L27.9039 22.5716L27.8478 22.2287L27.8353 22.1536L27.8069 21.9774L27.0832 17.5494L27.0694 17.4627L27.0638 17.4297L26.8559 16.1552L26.8399 16.0588C26.8074 15.9838 26.7325 15.9307 26.6452 15.9307C26.6188 15.9307 26.5932 15.9362 26.5703 15.9452L26.5467 15.9562L26.1205 16.1552L25.4156 16.4836L17.547 20.1535L17.5206 20.1659C17.4998 20.1734 17.477 20.1783 17.4534 20.1783C17.391 20.1783 17.3356 20.1479 17.3002 20.1025L17.269 20.0426C17.2635 20.0247 17.2593 20.0054 17.2593 19.9855C17.2593 19.9338 17.2801 19.8877 17.3127 19.8533L17.416 19.7961L24.6967 15.7861L25.0343 15.6003L25.0821 15.5741C25.1348 15.5355 25.1695 15.4742 25.1695 15.4047C25.1695 15.3351 25.1362 15.2759 25.0849 15.2374C25.08 15.234 25.0752 15.2305 25.0703 15.2271C24.5332 14.8373 23.9405 14.5199 23.3042 14.2913C23.2716 14.2796 23.2391 14.268 23.2058 14.2569C23.1982 14.2542 23.1899 14.2514 23.1822 14.2487C22.4787 14.0104 21.7253 13.8803 20.9392 13.8803C20.9358 13.8803 20.9323 13.8803 20.9281 13.8803C20.9247 13.8803 20.9212 13.8803 20.9177 13.8803C20.8443 13.8803 20.7715 13.8838 20.6994 13.8886C20.6321 13.8927 20.5656 13.892 20.4991 13.8961C20.4547 13.8989 20.4097 13.9058 20.3653 13.9071C20.3265 13.9085 20.287 13.9106 20.2489 13.914C20.0423 13.934 19.8385 13.965 19.6368 14.0022C19.6195 14.0056 19.6021 14.007 19.5848 14.0097C19.3769 14.0497 19.1724 14.1006 18.9714 14.1585C18.961 14.1612 18.9506 14.1633 18.9402 14.1667C18.7413 14.2252 18.5465 14.2934 18.3552 14.3685C18.3434 14.3733 18.3302 14.3774 18.3185 14.3816C18.132 14.4559 17.9511 14.5392 17.773 14.6287C17.7563 14.637 17.7383 14.6446 17.7216 14.6535C17.5802 14.7258 17.443 14.8043 17.3072 14.8863C17.2947 14.8938 17.2822 14.9014 17.2697 14.909C17.2552 14.9179 17.2406 14.9262 17.2268 14.9351C17.2018 14.9503 17.1768 14.964 17.1526 14.9799C17.0638 15.0364 16.9772 15.0956 16.8913 15.1568C16.8316 15.1988 16.7727 15.2415 16.7145 15.2856C16.702 15.2945 16.6902 15.3042 16.6778 15.3131C16.6563 15.329 16.6348 15.3448 16.6133 15.3606C16.5946 15.3751 16.5766 15.3909 16.5579 15.4054C16.5142 15.4405 16.4705 15.4749 16.4275 15.5107C16.4248 15.5135 16.422 15.5156 16.4186 15.5183C16.3576 15.5699 16.2972 15.6223 16.2376 15.676C16.1974 15.7118 16.1572 15.7476 16.1177 15.7841C16.1142 15.7875 16.1108 15.7903 16.1073 15.7937C16.1059 15.7951 16.1046 15.7965 16.1032 15.7979C15.9985 15.8963 15.898 15.9996 15.7996 16.1042C15.7455 16.1628 15.6907 16.2206 15.6388 16.2805C15.5563 16.3741 15.4779 16.4705 15.401 16.569C15.3358 16.6516 15.2721 16.7356 15.2111 16.8217C15.1536 16.9022 15.0981 16.9842 15.044 17.0668C14.9692 17.1825 14.8964 17.2995 14.8285 17.4193C14.7952 17.4772 14.7626 17.5357 14.7307 17.5949C14.6801 17.6899 14.6316 17.7863 14.5852 17.8841C14.563 17.9288 14.5415 17.9736 14.52 18.0183C14.1201 18.8625 13.8955 19.8051 13.8955 20.7993C13.8955 20.9887 13.9038 21.1759 13.9197 21.3612C14.0452 23.1802 14.87 24.8052 16.1309 25.9784C16.1482 25.9943 16.1655 26.0101 16.1829 26.0266C16.2016 26.039 16.2231 26.0473 16.2453 26.0528C16.2556 26.0555 16.2661 26.0576 16.2772 26.0583C16.2931 26.0583 16.3083 26.0583 16.3236 26.0569C16.3264 26.0569 16.3284 26.0569 16.3305 26.0569C16.4047 26.0542 16.4789 26.0514 16.553 26.0493C16.6431 26.0466 16.7339 26.0445 16.8247 26.0445C18.7426 26.0445 20.5712 26.4198 22.2451 27.0959C22.5154 27.2047 22.7809 27.321 23.0429 27.4457C23.0734 27.4601 23.1039 27.4732 23.1344 27.487C23.149 27.4939 23.1642 27.5001 23.1781 27.5069C24.3197 28.064 25.3753 28.7669 26.3229 29.5897C26.3374 29.607 26.3541 29.6214 26.3728 29.6331C26.4053 29.6531 26.4435 29.6655 26.4843 29.6655H27.6987C27.8159 29.6655 27.9109 29.5712 27.9109 29.4548C27.9109 29.4445 27.9095 29.4348 27.9081 29.4252C27.9046 29.4031 27.8984 29.3818 27.8887 29.3625M26.9377 22.018C26.9446 22.018 26.9515 22.016 26.9585 22.016C26.9515 22.016 26.9446 22.0173 26.9377 22.018ZM18.5028 15.1623C18.5368 15.1479 18.5701 15.1341 18.6033 15.121C18.613 15.1176 18.6227 15.1141 18.6311 15.1107C18.6359 15.1086 18.6408 15.1073 18.6456 15.1052C18.823 15.0356 18.988 14.9785 19.1516 14.9296C19.1661 14.9262 19.1807 14.922 19.1946 14.9179C19.3741 14.8663 19.5515 14.8229 19.7221 14.7891C19.7435 14.7864 19.763 14.7829 19.7824 14.7795C19.9771 14.743 20.1546 14.7176 20.3251 14.701C20.35 14.699 20.3937 14.6934 20.4339 14.6921C20.4727 14.6907 20.5074 14.6872 20.5462 14.6852C20.585 14.6831 20.6238 14.6804 20.6619 14.6776C20.7472 14.6721 20.8269 14.6721 20.9004 14.6714C20.9094 14.6714 20.9184 14.6714 20.9281 14.6714C20.9378 14.6714 20.9476 14.6714 20.9572 14.6714C21.9048 14.6742 22.8239 14.8904 23.6646 15.3021C23.6806 15.3104 23.6965 15.318 23.7125 15.3262C23.725 15.34 23.7333 15.3579 23.7333 15.3785C23.7333 15.3937 23.7284 15.4074 23.7215 15.4191L23.655 15.4556L22.9507 15.844L22.9091 15.8667C22.8987 15.8694 22.8883 15.8722 22.8773 15.8722C22.871 15.8722 22.8655 15.8715 22.8599 15.8701C22.8433 15.8633 22.8266 15.8564 22.81 15.8488C21.7647 15.4012 20.6148 15.1485 19.4039 15.1485C19.1509 15.1485 18.9021 15.1637 18.656 15.1885C18.6082 15.1933 18.561 15.1981 18.5132 15.2036C18.5077 15.1926 18.5035 15.1802 18.5035 15.1671C18.5035 15.1651 18.5035 15.163 18.5035 15.161M26.9079 28.873C26.8386 28.9639 26.7083 28.873 26.7083 28.873C25.7371 28.0488 24.6683 27.3506 23.5302 26.7957C23.4969 26.7792 23.4629 26.764 23.429 26.7496C23.4151 26.7434 23.4012 26.7372 23.3874 26.731C23.1157 26.6016 22.8322 26.4776 22.5459 26.3619C20.7223 25.6259 18.7981 25.2527 16.8254 25.2527C16.7589 25.2527 16.6902 25.2534 16.6126 25.2555C16.6071 25.2555 16.6015 25.2568 16.5953 25.2568C16.5918 25.2568 16.5891 25.2562 16.5856 25.2562C16.5468 25.2541 16.5121 25.2389 16.4851 25.2149C16.4789 25.2086 16.4726 25.2017 16.4664 25.1956C16.1212 24.8437 15.8224 24.4561 15.5743 24.0409C15.5611 24.0189 15.548 23.9975 15.5355 23.9762C15.5299 23.9597 15.5265 23.9424 15.5265 23.9245C15.5265 23.8433 15.5847 23.7758 15.6616 23.7607C15.6907 23.7627 15.7205 23.7648 15.7497 23.7669C20.0347 24.1139 23.901 25.9192 26.8503 28.6829C26.8503 28.6829 26.9779 28.7828 26.9086 28.873" fill="white"/>
  <path d="M26.9395 22.0194C26.9465 22.0194 26.9536 22.0173 26.9607 22.0173C26.9536 22.0173 26.9465 22.0187 26.9402 22.0194" fill="white"/>
  <path d="M21.5562 9.88268C23.1705 9.96737 24.6927 10.3956 26.0519 11.0945C26.1171 11.1282 26.1975 11.1089 26.2391 11.049L26.5746 10.5705C26.6245 10.4996 26.6009 10.3998 26.5232 10.3598C24.9852 9.55425 23.341 9.11497 21.6976 9.01582C21.6276 9.01169 21.5652 9.05782 21.5472 9.1253C21.4924 9.33599 21.4509 9.53222 21.4183 9.7133C21.403 9.79937 21.4675 9.87786 21.5555 9.88268" fill="white"/>
  <path d="M11.0192 25.743C10.315 24.3253 9.90877 22.7355 9.88174 21.0541C9.88035 20.9666 9.80341 20.8991 9.71608 20.9102C9.53309 20.9343 9.33277 20.9673 9.1179 21.0121C9.04858 21.0265 8.99798 21.0878 9.00006 21.1587C9.04234 22.8546 9.44852 24.5249 10.1909 26.0521C10.2221 26.1161 10.2955 26.1478 10.3642 26.1285C10.5742 26.07 10.7662 26.008 10.9395 25.9454C11.022 25.9158 11.0587 25.8208 11.0199 25.743" fill="white"/>
  <path d="M11.4405 26.512C11.3955 26.4377 11.2957 26.417 11.2264 26.4707C11.0794 26.5836 10.9221 26.7131 10.7585 26.8597C10.7065 26.9065 10.6947 26.983 10.7308 27.0422C11.3283 28.022 12.0755 28.9246 12.9613 29.713C13.0265 29.7708 13.1276 29.7584 13.1776 29.6875L13.5186 29.2007C13.5602 29.1408 13.5505 29.0602 13.4964 29.0114C12.6944 28.285 11.9999 27.4429 11.4398 26.512" fill="white"/>
  <path d="M11.491 14.8511C11.5582 14.9069 11.6587 14.8904 11.7072 14.8181C12.6076 13.463 13.8026 12.318 15.2 11.4704C15.2748 11.425 15.2942 11.3265 15.2416 11.2577C15.1293 11.1124 15.001 10.9575 14.8555 10.7964C14.8077 10.744 14.7293 10.7316 14.669 10.7688C13.2529 11.6371 12.0011 12.811 11.0224 14.2645C10.9829 14.323 10.9926 14.4015 11.0432 14.4511C11.1998 14.6019 11.3503 14.7354 11.4917 14.8518" fill="white"/>
  <path d="M15.7595 10.9706C15.79 11.0525 15.885 11.0883 15.9633 11.0484C17.3849 10.333 18.9826 9.91366 20.6753 9.87029C20.7626 9.86822 20.8291 9.79248 20.8173 9.70642C20.7924 9.52533 20.7585 9.32704 20.7134 9.11566C20.6988 9.04681 20.6365 8.99723 20.5657 8.99999C18.8593 9.05714 17.1805 9.47714 15.6493 10.229C15.5862 10.26 15.555 10.3323 15.5737 10.3998C15.6333 10.6084 15.6964 10.7984 15.7595 10.9706Z" fill="white"/>
  <path d="M9.13497 20.1962C9.34984 20.2498 9.55016 20.2912 9.73384 20.3228C9.8191 20.3373 9.89673 20.2746 9.90227 20.1886C10.0062 18.5162 10.4859 16.9442 11.2581 15.5562C11.2997 15.4811 11.2678 15.3861 11.1881 15.353C11.0175 15.2828 10.8276 15.2119 10.619 15.1437C10.5524 15.1217 10.479 15.1499 10.4457 15.2112C9.60423 16.7487 9.13982 18.397 9.02476 20.0468C9.0199 20.1163 9.06704 20.1789 9.13497 20.1962Z" fill="white"/>
  <path d="M15.6052 26.185C15.6052 26.1581 15.5968 26.1327 15.583 26.112C15.5712 26.0996 15.5594 26.0879 15.5476 26.0762C15.5262 26.061 15.4998 26.0521 15.4714 26.0521C15.3972 26.0521 15.3369 26.112 15.3369 26.185C15.3369 26.258 15.3972 26.3185 15.4714 26.3185C15.5088 26.3185 15.5428 26.3027 15.567 26.2786L15.5913 26.2442C15.6003 26.2263 15.6059 26.2063 15.6059 26.185" fill="white"/>
  <path d="M23.9833 13.9567C23.9833 13.9023 24.0276 13.8583 24.0824 13.8583C24.1371 13.8583 24.1822 13.9023 24.1822 13.9567C24.1822 13.9732 24.1774 13.9884 24.1704 14.0022L25.9206 11.5042C24.4629 10.7413 22.8978 10.3468 21.3403 10.2931C21.3306 10.3998 21.3237 10.4969 21.3202 10.5809C21.5053 10.6683 21.6307 10.859 21.6224 11.0766C21.6127 11.3527 21.3805 11.5799 21.1026 11.5854C20.799 11.5916 20.5536 11.3458 20.5598 11.047C20.564 10.8329 20.6957 10.6518 20.8821 10.5726C20.8821 10.4886 20.8794 10.3929 20.8738 10.2869C19.1715 10.302 17.492 10.722 15.9851 11.5097C16.026 11.5971 16.0648 11.6756 16.1008 11.7438C16.3053 11.728 16.5091 11.8305 16.6124 12.0226C16.7427 12.2664 16.6561 12.5783 16.4183 12.7215C16.1584 12.8778 15.8222 12.7862 15.6773 12.5246C15.5734 12.3373 15.5962 12.1149 15.7175 11.9538C15.6787 11.8877 15.633 11.8133 15.5803 11.7328C14.1531 12.5597 12.8999 13.7288 11.9579 15.2057C12.0335 15.258 12.1028 15.3042 12.1659 15.3441C12.335 15.2291 12.5637 15.216 12.7488 15.3317C12.9845 15.4784 13.0663 15.791 12.9325 16.0333C12.7862 16.2977 12.4494 16.3858 12.1915 16.2309C12.0071 16.1201 11.915 15.9163 11.9385 15.7166C11.8741 15.6801 11.8006 15.6402 11.7188 15.5982C10.8406 17.1136 10.381 18.7585 10.3082 20.3986C10.4039 20.4068 10.4919 20.4124 10.5689 20.4158C10.6576 20.2319 10.8489 20.1073 11.0679 20.1156C11.3459 20.1252 11.5746 20.3559 11.5802 20.632C11.5864 20.9336 11.339 21.1773 11.0381 21.1711C10.8226 21.167 10.6403 21.0355 10.5606 20.8509C10.4829 20.8509 10.3949 20.8537 10.2979 20.8585C10.2965 22.5502 10.7033 24.2227 11.4811 25.7264C11.5781 25.6824 11.6647 25.6397 11.7396 25.6011C11.7236 25.398 11.8269 25.1949 12.0203 25.093C12.2664 24.9635 12.5797 25.0496 12.7239 25.2857C12.8812 25.544 12.789 25.8779 12.5256 26.0218C12.3371 26.1251 12.1132 26.1017 11.951 25.9818C11.8775 26.0245 11.7944 26.0755 11.7035 26.134C12.2581 27.1 12.972 27.9875 13.8329 28.7539L15.5671 26.2786C15.5429 26.3034 15.5089 26.3185 15.4715 26.3185C15.3897 26.3185 15.3245 26.2456 15.3391 26.1616C15.3481 26.1072 15.3931 26.0631 15.4479 26.0541C15.4853 26.048 15.52 26.0569 15.5477 26.0762C14.2495 24.7418 13.4454 22.931 13.4309 20.9322C13.4004 16.8072 16.7766 13.4114 20.93 13.3928C22.0362 13.388 23.087 13.6214 24.0346 14.0428C24.0041 14.0263 23.9826 13.9939 23.9826 13.9567" fill="white"/>
  <path d="M24.0352 14.0428C24.04 14.0457 24.0454 14.0479 24.0503 14.0501C24.0454 14.0479 24.04 14.045 24.0352 14.0428Z" fill="white"/>
  <path d="M24.0825 14.0559C24.1116 14.0559 24.1373 14.0435 24.1553 14.0235L24.1698 14.0029C24.1768 13.9891 24.1816 13.974 24.1816 13.9574C24.1816 13.903 24.1373 13.8589 24.0825 13.8589C24.0277 13.8589 23.9834 13.903 23.9834 13.9574C23.9834 13.9946 24.0042 14.027 24.0347 14.0435C24.0402 14.0455 24.0451 14.0483 24.0499 14.0504C24.0603 14.0538 24.0707 14.0559 24.0825 14.0559Z" fill="white"/>
</svg>
`
);

// node_modules/marked/lib/marked.esm.js
function _getDefaults() {
  return {
    async: false,
    breaks: false,
    extensions: null,
    gfm: true,
    hooks: null,
    pedantic: false,
    renderer: null,
    silent: false,
    tokenizer: null,
    walkTokens: null
  };
}
var _defaults = _getDefaults();
function changeDefaults(newDefaults) {
  _defaults = newDefaults;
}
var noopTest = { exec: () => null };
function edit(regex, opt = "") {
  let source = typeof regex === "string" ? regex : regex.source;
  const obj = {
    replace: (name14, val) => {
      let valSource = typeof val === "string" ? val : val.source;
      valSource = valSource.replace(other.caret, "$1");
      source = source.replace(name14, valSource);
      return obj;
    },
    getRegex: () => {
      return new RegExp(source, opt);
    }
  };
  return obj;
}
var other = {
  codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
  outputLinkReplace: /\\([\[\]])/g,
  indentCodeCompensation: /^(\s+)(?:```)/,
  beginningSpace: /^\s+/,
  endingHash: /#$/,
  startingSpaceChar: /^ /,
  endingSpaceChar: / $/,
  nonSpaceChar: /[^ ]/,
  newLineCharGlobal: /\n/g,
  tabCharGlobal: /\t/g,
  multipleSpaceGlobal: /\s+/g,
  blankLine: /^[ \t]*$/,
  doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
  blockquoteStart: /^ {0,3}>/,
  blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
  blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
  listReplaceTabs: /^\t+/,
  listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
  listIsTask: /^\[[ xX]\] /,
  listReplaceTask: /^\[[ xX]\] +/,
  anyLine: /\n.*\n/,
  hrefBrackets: /^<(.*)>$/,
  tableDelimiter: /[:|]/,
  tableAlignChars: /^\||\| *$/g,
  tableRowBlankLine: /\n[ \t]*$/,
  tableAlignRight: /^ *-+: *$/,
  tableAlignCenter: /^ *:-+: *$/,
  tableAlignLeft: /^ *:-+ *$/,
  startATag: /^<a /i,
  endATag: /^<\/a>/i,
  startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
  endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
  startAngleBracket: /^</,
  endAngleBracket: />$/,
  pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
  unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
  escapeTest: /[&<>"']/,
  escapeReplace: /[&<>"']/g,
  escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
  escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
  unescapeTest: /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig,
  caret: /(^|[^\[])\^/g,
  percentDecode: /%25/g,
  findPipe: /\|/g,
  splitPipe: / \|/,
  slashPipe: /\\\|/g,
  carriageReturn: /\r\n|\r/g,
  spaceLine: /^ +$/gm,
  notSpaceStart: /^\S*/,
  endingNewline: /\n$/,
  listItemRegex: (bull) => new RegExp(`^( {0,3}${bull})((?:[	 ][^\\n]*)?(?:\\n|$))`),
  nextBulletRegex: (indent) => new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`),
  hrRegex: (indent) => new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
  fencesBeginRegex: (indent) => new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`),
  headingBeginRegex: (indent) => new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`),
  htmlBeginRegex: (indent) => new RegExp(`^ {0,${Math.min(3, indent - 1)}}<(?:[a-z].*>|!--)`, "i")
};
var newline = /^(?:[ \t]*(?:\n|$))+/;
var blockCode = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/;
var fences = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/;
var hr = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/;
var heading = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/;
var bullet = /(?:[*+-]|\d{1,9}[.)])/;
var lheading = edit(/^(?!bull |blockCode|fences|blockquote|heading|html)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html))+?)\n {0,3}(=+|-+) *(?:\n+|$)/).replace(/bull/g, bullet).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).getRegex();
var _paragraph = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/;
var blockText = /^[^\n]+/;
var _blockLabel = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
var def = edit(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", _blockLabel).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex();
var list = edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, bullet).getRegex();
var _tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
var _comment = /<!--(?:-?>|[\s\S]*?(?:-->|$))/;
var html = edit("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", _comment).replace("tag", _tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
var paragraph = edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag).getRegex();
var blockquote = edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", paragraph).getRegex();
var blockNormal = {
  blockquote,
  code: blockCode,
  def,
  fences,
  heading,
  hr,
  html,
  lheading,
  list,
  newline,
  paragraph,
  table: noopTest,
  text: blockText
};
var gfmTable = edit("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag).getRegex();
var blockGfm = {
  ...blockNormal,
  table: gfmTable,
  paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", gfmTable).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag).getRegex()
};
var blockPedantic = {
  ...blockNormal,
  html: edit(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", _comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
  heading: /^(#{1,6})(.*)(?:\n+|$)/,
  fences: noopTest,
  // fences not supported
  lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", lheading).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
};
var escape$1 = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/;
var inlineCode = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/;
var br = /^( {2,}|\\)\n(?!\s*$)/;
var inlineText = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/;
var _punctuation = /[\p{P}\p{S}]/u;
var _punctuationOrSpace = /[\s\p{P}\p{S}]/u;
var _notPunctuationOrSpace = /[^\s\p{P}\p{S}]/u;
var punctuation = edit(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, _punctuationOrSpace).getRegex();
var _punctuationGfmStrongEm = /(?!~)[\p{P}\p{S}]/u;
var _punctuationOrSpaceGfmStrongEm = /(?!~)[\s\p{P}\p{S}]/u;
var _notPunctuationOrSpaceGfmStrongEm = /(?:[^\s\p{P}\p{S}]|~)/u;
var blockSkip = /\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<[^<>]*?>/g;
var emStrongLDelimCore = /^(?:\*+(?:((?!\*)punct)|[^\s*]))|^_+(?:((?!_)punct)|([^\s_]))/;
var emStrongLDelim = edit(emStrongLDelimCore, "u").replace(/punct/g, _punctuation).getRegex();
var emStrongLDelimGfm = edit(emStrongLDelimCore, "u").replace(/punct/g, _punctuationGfmStrongEm).getRegex();
var emStrongRDelimAstCore = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)";
var emStrongRDelimAst = edit(emStrongRDelimAstCore, "gu").replace(/notPunctSpace/g, _notPunctuationOrSpace).replace(/punctSpace/g, _punctuationOrSpace).replace(/punct/g, _punctuation).getRegex();
var emStrongRDelimAstGfm = edit(emStrongRDelimAstCore, "gu").replace(/notPunctSpace/g, _notPunctuationOrSpaceGfmStrongEm).replace(/punctSpace/g, _punctuationOrSpaceGfmStrongEm).replace(/punct/g, _punctuationGfmStrongEm).getRegex();
var emStrongRDelimUnd = edit("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, _notPunctuationOrSpace).replace(/punctSpace/g, _punctuationOrSpace).replace(/punct/g, _punctuation).getRegex();
var anyPunctuation = edit(/\\(punct)/, "gu").replace(/punct/g, _punctuation).getRegex();
var autolink = edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex();
var _inlineComment = edit(_comment).replace("(?:-->|$)", "-->").getRegex();
var tag = edit("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", _inlineComment).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex();
var _inlineLabel = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
var link = edit(/^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/).replace("label", _inlineLabel).replace("href", /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex();
var reflink = edit(/^!?\[(label)\]\[(ref)\]/).replace("label", _inlineLabel).replace("ref", _blockLabel).getRegex();
var nolink = edit(/^!?\[(ref)\](?:\[\])?/).replace("ref", _blockLabel).getRegex();
var reflinkSearch = edit("reflink|nolink(?!\\()", "g").replace("reflink", reflink).replace("nolink", nolink).getRegex();
var inlineNormal = {
  _backpedal: noopTest,
  // only used for GFM url
  anyPunctuation,
  autolink,
  blockSkip,
  br,
  code: inlineCode,
  del: noopTest,
  emStrongLDelim,
  emStrongRDelimAst,
  emStrongRDelimUnd,
  escape: escape$1,
  link,
  nolink,
  punctuation,
  reflink,
  reflinkSearch,
  tag,
  text: inlineText,
  url: noopTest
};
var inlinePedantic = {
  ...inlineNormal,
  link: edit(/^!?\[(label)\]\((.*?)\)/).replace("label", _inlineLabel).getRegex(),
  reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", _inlineLabel).getRegex()
};
var inlineGfm = {
  ...inlineNormal,
  emStrongRDelimAst: emStrongRDelimAstGfm,
  emStrongLDelim: emStrongLDelimGfm,
  url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
  _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
  del: /^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/,
  text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
};
var inlineBreaks = {
  ...inlineGfm,
  br: edit(br).replace("{2,}", "*").getRegex(),
  text: edit(inlineGfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
};
var block = {
  normal: blockNormal,
  gfm: blockGfm,
  pedantic: blockPedantic
};
var inline = {
  normal: inlineNormal,
  gfm: inlineGfm,
  breaks: inlineBreaks,
  pedantic: inlinePedantic
};
var escapeReplacements = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};
var getEscapeReplacement = (ch) => escapeReplacements[ch];
function escape(html2, encode) {
  if (encode) {
    if (other.escapeTest.test(html2)) {
      return html2.replace(other.escapeReplace, getEscapeReplacement);
    }
  } else {
    if (other.escapeTestNoEncode.test(html2)) {
      return html2.replace(other.escapeReplaceNoEncode, getEscapeReplacement);
    }
  }
  return html2;
}
function cleanUrl(href) {
  try {
    href = encodeURI(href).replace(other.percentDecode, "%");
  } catch {
    return null;
  }
  return href;
}
function splitCells(tableRow, count) {
  const row = tableRow.replace(other.findPipe, (match, offset, str) => {
    let escaped = false;
    let curr = offset;
    while (--curr >= 0 && str[curr] === "\\")
      escaped = !escaped;
    if (escaped) {
      return "|";
    } else {
      return " |";
    }
  }), cells = row.split(other.splitPipe);
  let i = 0;
  if (!cells[0].trim()) {
    cells.shift();
  }
  if (cells.length > 0 && !cells.at(-1)?.trim()) {
    cells.pop();
  }
  if (count) {
    if (cells.length > count) {
      cells.splice(count);
    } else {
      while (cells.length < count)
        cells.push("");
    }
  }
  for (; i < cells.length; i++) {
    cells[i] = cells[i].trim().replace(other.slashPipe, "|");
  }
  return cells;
}
function rtrim(str, c, invert) {
  const l = str.length;
  if (l === 0) {
    return "";
  }
  let suffLen = 0;
  while (suffLen < l) {
    const currChar = str.charAt(l - suffLen - 1);
    if (currChar === c && true) {
      suffLen++;
    } else {
      break;
    }
  }
  return str.slice(0, l - suffLen);
}
function findClosingBracket(str, b) {
  if (str.indexOf(b[1]) === -1) {
    return -1;
  }
  let level = 0;
  for (let i = 0; i < str.length; i++) {
    if (str[i] === "\\") {
      i++;
    } else if (str[i] === b[0]) {
      level++;
    } else if (str[i] === b[1]) {
      level--;
      if (level < 0) {
        return i;
      }
    }
  }
  return -1;
}
function outputLink(cap, link2, raw, lexer2, rules) {
  const href = link2.href;
  const title = link2.title || null;
  const text = cap[1].replace(rules.other.outputLinkReplace, "$1");
  if (cap[0].charAt(0) !== "!") {
    lexer2.state.inLink = true;
    const token = {
      type: "link",
      raw,
      href,
      title,
      text,
      tokens: lexer2.inlineTokens(text)
    };
    lexer2.state.inLink = false;
    return token;
  }
  return {
    type: "image",
    raw,
    href,
    title,
    text
  };
}
function indentCodeCompensation(raw, text, rules) {
  const matchIndentToCode = raw.match(rules.other.indentCodeCompensation);
  if (matchIndentToCode === null) {
    return text;
  }
  const indentToCode = matchIndentToCode[1];
  return text.split("\n").map((node) => {
    const matchIndentInNode = node.match(rules.other.beginningSpace);
    if (matchIndentInNode === null) {
      return node;
    }
    const [indentInNode] = matchIndentInNode;
    if (indentInNode.length >= indentToCode.length) {
      return node.slice(indentToCode.length);
    }
    return node;
  }).join("\n");
}
var _Tokenizer = class {
  options;
  rules;
  // set by the lexer
  lexer;
  // set by the lexer
  constructor(options2) {
    this.options = options2 || _defaults;
  }
  space(src) {
    const cap = this.rules.block.newline.exec(src);
    if (cap && cap[0].length > 0) {
      return {
        type: "space",
        raw: cap[0]
      };
    }
  }
  code(src) {
    const cap = this.rules.block.code.exec(src);
    if (cap) {
      const text = cap[0].replace(this.rules.other.codeRemoveIndent, "");
      return {
        type: "code",
        raw: cap[0],
        codeBlockStyle: "indented",
        text: !this.options.pedantic ? rtrim(text, "\n") : text
      };
    }
  }
  fences(src) {
    const cap = this.rules.block.fences.exec(src);
    if (cap) {
      const raw = cap[0];
      const text = indentCodeCompensation(raw, cap[3] || "", this.rules);
      return {
        type: "code",
        raw,
        lang: cap[2] ? cap[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : cap[2],
        text
      };
    }
  }
  heading(src) {
    const cap = this.rules.block.heading.exec(src);
    if (cap) {
      let text = cap[2].trim();
      if (this.rules.other.endingHash.test(text)) {
        const trimmed = rtrim(text, "#");
        if (this.options.pedantic) {
          text = trimmed.trim();
        } else if (!trimmed || this.rules.other.endingSpaceChar.test(trimmed)) {
          text = trimmed.trim();
        }
      }
      return {
        type: "heading",
        raw: cap[0],
        depth: cap[1].length,
        text,
        tokens: this.lexer.inline(text)
      };
    }
  }
  hr(src) {
    const cap = this.rules.block.hr.exec(src);
    if (cap) {
      return {
        type: "hr",
        raw: rtrim(cap[0], "\n")
      };
    }
  }
  blockquote(src) {
    const cap = this.rules.block.blockquote.exec(src);
    if (cap) {
      let lines = rtrim(cap[0], "\n").split("\n");
      let raw = "";
      let text = "";
      const tokens = [];
      while (lines.length > 0) {
        let inBlockquote = false;
        const currentLines = [];
        let i;
        for (i = 0; i < lines.length; i++) {
          if (this.rules.other.blockquoteStart.test(lines[i])) {
            currentLines.push(lines[i]);
            inBlockquote = true;
          } else if (!inBlockquote) {
            currentLines.push(lines[i]);
          } else {
            break;
          }
        }
        lines = lines.slice(i);
        const currentRaw = currentLines.join("\n");
        const currentText = currentRaw.replace(this.rules.other.blockquoteSetextReplace, "\n    $1").replace(this.rules.other.blockquoteSetextReplace2, "");
        raw = raw ? `${raw}
${currentRaw}` : currentRaw;
        text = text ? `${text}
${currentText}` : currentText;
        const top = this.lexer.state.top;
        this.lexer.state.top = true;
        this.lexer.blockTokens(currentText, tokens, true);
        this.lexer.state.top = top;
        if (lines.length === 0) {
          break;
        }
        const lastToken = tokens.at(-1);
        if (lastToken?.type === "code") {
          break;
        } else if (lastToken?.type === "blockquote") {
          const oldToken = lastToken;
          const newText = oldToken.raw + "\n" + lines.join("\n");
          const newToken = this.blockquote(newText);
          tokens[tokens.length - 1] = newToken;
          raw = raw.substring(0, raw.length - oldToken.raw.length) + newToken.raw;
          text = text.substring(0, text.length - oldToken.text.length) + newToken.text;
          break;
        } else if (lastToken?.type === "list") {
          const oldToken = lastToken;
          const newText = oldToken.raw + "\n" + lines.join("\n");
          const newToken = this.list(newText);
          tokens[tokens.length - 1] = newToken;
          raw = raw.substring(0, raw.length - lastToken.raw.length) + newToken.raw;
          text = text.substring(0, text.length - oldToken.raw.length) + newToken.raw;
          lines = newText.substring(tokens.at(-1).raw.length).split("\n");
          continue;
        }
      }
      return {
        type: "blockquote",
        raw,
        tokens,
        text
      };
    }
  }
  list(src) {
    let cap = this.rules.block.list.exec(src);
    if (cap) {
      let bull = cap[1].trim();
      const isordered = bull.length > 1;
      const list2 = {
        type: "list",
        raw: "",
        ordered: isordered,
        start: isordered ? +bull.slice(0, -1) : "",
        loose: false,
        items: []
      };
      bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
      if (this.options.pedantic) {
        bull = isordered ? bull : "[*+-]";
      }
      const itemRegex = this.rules.other.listItemRegex(bull);
      let endsWithBlankLine = false;
      while (src) {
        let endEarly = false;
        let raw = "";
        let itemContents = "";
        if (!(cap = itemRegex.exec(src))) {
          break;
        }
        if (this.rules.block.hr.test(src)) {
          break;
        }
        raw = cap[0];
        src = src.substring(raw.length);
        let line = cap[2].split("\n", 1)[0].replace(this.rules.other.listReplaceTabs, (t) => " ".repeat(3 * t.length));
        let nextLine = src.split("\n", 1)[0];
        let blankLine = !line.trim();
        let indent = 0;
        if (this.options.pedantic) {
          indent = 2;
          itemContents = line.trimStart();
        } else if (blankLine) {
          indent = cap[1].length + 1;
        } else {
          indent = cap[2].search(this.rules.other.nonSpaceChar);
          indent = indent > 4 ? 1 : indent;
          itemContents = line.slice(indent);
          indent += cap[1].length;
        }
        if (blankLine && this.rules.other.blankLine.test(nextLine)) {
          raw += nextLine + "\n";
          src = src.substring(nextLine.length + 1);
          endEarly = true;
        }
        if (!endEarly) {
          const nextBulletRegex = this.rules.other.nextBulletRegex(indent);
          const hrRegex = this.rules.other.hrRegex(indent);
          const fencesBeginRegex = this.rules.other.fencesBeginRegex(indent);
          const headingBeginRegex = this.rules.other.headingBeginRegex(indent);
          const htmlBeginRegex = this.rules.other.htmlBeginRegex(indent);
          while (src) {
            const rawLine = src.split("\n", 1)[0];
            let nextLineWithoutTabs;
            nextLine = rawLine;
            if (this.options.pedantic) {
              nextLine = nextLine.replace(this.rules.other.listReplaceNesting, "  ");
              nextLineWithoutTabs = nextLine;
            } else {
              nextLineWithoutTabs = nextLine.replace(this.rules.other.tabCharGlobal, "    ");
            }
            if (fencesBeginRegex.test(nextLine)) {
              break;
            }
            if (headingBeginRegex.test(nextLine)) {
              break;
            }
            if (htmlBeginRegex.test(nextLine)) {
              break;
            }
            if (nextBulletRegex.test(nextLine)) {
              break;
            }
            if (hrRegex.test(nextLine)) {
              break;
            }
            if (nextLineWithoutTabs.search(this.rules.other.nonSpaceChar) >= indent || !nextLine.trim()) {
              itemContents += "\n" + nextLineWithoutTabs.slice(indent);
            } else {
              if (blankLine) {
                break;
              }
              if (line.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4) {
                break;
              }
              if (fencesBeginRegex.test(line)) {
                break;
              }
              if (headingBeginRegex.test(line)) {
                break;
              }
              if (hrRegex.test(line)) {
                break;
              }
              itemContents += "\n" + nextLine;
            }
            if (!blankLine && !nextLine.trim()) {
              blankLine = true;
            }
            raw += rawLine + "\n";
            src = src.substring(rawLine.length + 1);
            line = nextLineWithoutTabs.slice(indent);
          }
        }
        if (!list2.loose) {
          if (endsWithBlankLine) {
            list2.loose = true;
          } else if (this.rules.other.doubleBlankLine.test(raw)) {
            endsWithBlankLine = true;
          }
        }
        let istask = null;
        let ischecked;
        if (this.options.gfm) {
          istask = this.rules.other.listIsTask.exec(itemContents);
          if (istask) {
            ischecked = istask[0] !== "[ ] ";
            itemContents = itemContents.replace(this.rules.other.listReplaceTask, "");
          }
        }
        list2.items.push({
          type: "list_item",
          raw,
          task: !!istask,
          checked: ischecked,
          loose: false,
          text: itemContents,
          tokens: []
        });
        list2.raw += raw;
      }
      const lastItem = list2.items.at(-1);
      if (lastItem) {
        lastItem.raw = lastItem.raw.trimEnd();
        lastItem.text = lastItem.text.trimEnd();
      } else {
        return;
      }
      list2.raw = list2.raw.trimEnd();
      for (let i = 0; i < list2.items.length; i++) {
        this.lexer.state.top = false;
        list2.items[i].tokens = this.lexer.blockTokens(list2.items[i].text, []);
        if (!list2.loose) {
          const spacers = list2.items[i].tokens.filter((t) => t.type === "space");
          const hasMultipleLineBreaks = spacers.length > 0 && spacers.some((t) => this.rules.other.anyLine.test(t.raw));
          list2.loose = hasMultipleLineBreaks;
        }
      }
      if (list2.loose) {
        for (let i = 0; i < list2.items.length; i++) {
          list2.items[i].loose = true;
        }
      }
      return list2;
    }
  }
  html(src) {
    const cap = this.rules.block.html.exec(src);
    if (cap) {
      const token = {
        type: "html",
        block: true,
        raw: cap[0],
        pre: cap[1] === "pre" || cap[1] === "script" || cap[1] === "style",
        text: cap[0]
      };
      return token;
    }
  }
  def(src) {
    const cap = this.rules.block.def.exec(src);
    if (cap) {
      const tag2 = cap[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " ");
      const href = cap[2] ? cap[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "";
      const title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : cap[3];
      return {
        type: "def",
        tag: tag2,
        raw: cap[0],
        href,
        title
      };
    }
  }
  table(src) {
    const cap = this.rules.block.table.exec(src);
    if (!cap) {
      return;
    }
    if (!this.rules.other.tableDelimiter.test(cap[2])) {
      return;
    }
    const headers = splitCells(cap[1]);
    const aligns = cap[2].replace(this.rules.other.tableAlignChars, "").split("|");
    const rows = cap[3]?.trim() ? cap[3].replace(this.rules.other.tableRowBlankLine, "").split("\n") : [];
    const item = {
      type: "table",
      raw: cap[0],
      header: [],
      align: [],
      rows: []
    };
    if (headers.length !== aligns.length) {
      return;
    }
    for (const align of aligns) {
      if (this.rules.other.tableAlignRight.test(align)) {
        item.align.push("right");
      } else if (this.rules.other.tableAlignCenter.test(align)) {
        item.align.push("center");
      } else if (this.rules.other.tableAlignLeft.test(align)) {
        item.align.push("left");
      } else {
        item.align.push(null);
      }
    }
    for (let i = 0; i < headers.length; i++) {
      item.header.push({
        text: headers[i],
        tokens: this.lexer.inline(headers[i]),
        header: true,
        align: item.align[i]
      });
    }
    for (const row of rows) {
      item.rows.push(splitCells(row, item.header.length).map((cell, i) => {
        return {
          text: cell,
          tokens: this.lexer.inline(cell),
          header: false,
          align: item.align[i]
        };
      }));
    }
    return item;
  }
  lheading(src) {
    const cap = this.rules.block.lheading.exec(src);
    if (cap) {
      return {
        type: "heading",
        raw: cap[0],
        depth: cap[2].charAt(0) === "=" ? 1 : 2,
        text: cap[1],
        tokens: this.lexer.inline(cap[1])
      };
    }
  }
  paragraph(src) {
    const cap = this.rules.block.paragraph.exec(src);
    if (cap) {
      const text = cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1];
      return {
        type: "paragraph",
        raw: cap[0],
        text,
        tokens: this.lexer.inline(text)
      };
    }
  }
  text(src) {
    const cap = this.rules.block.text.exec(src);
    if (cap) {
      return {
        type: "text",
        raw: cap[0],
        text: cap[0],
        tokens: this.lexer.inline(cap[0])
      };
    }
  }
  escape(src) {
    const cap = this.rules.inline.escape.exec(src);
    if (cap) {
      return {
        type: "escape",
        raw: cap[0],
        text: cap[1]
      };
    }
  }
  tag(src) {
    const cap = this.rules.inline.tag.exec(src);
    if (cap) {
      if (!this.lexer.state.inLink && this.rules.other.startATag.test(cap[0])) {
        this.lexer.state.inLink = true;
      } else if (this.lexer.state.inLink && this.rules.other.endATag.test(cap[0])) {
        this.lexer.state.inLink = false;
      }
      if (!this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(cap[0])) {
        this.lexer.state.inRawBlock = true;
      } else if (this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(cap[0])) {
        this.lexer.state.inRawBlock = false;
      }
      return {
        type: "html",
        raw: cap[0],
        inLink: this.lexer.state.inLink,
        inRawBlock: this.lexer.state.inRawBlock,
        block: false,
        text: cap[0]
      };
    }
  }
  link(src) {
    const cap = this.rules.inline.link.exec(src);
    if (cap) {
      const trimmedUrl = cap[2].trim();
      if (!this.options.pedantic && this.rules.other.startAngleBracket.test(trimmedUrl)) {
        if (!this.rules.other.endAngleBracket.test(trimmedUrl)) {
          return;
        }
        const rtrimSlash = rtrim(trimmedUrl.slice(0, -1), "\\");
        if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) {
          return;
        }
      } else {
        const lastParenIndex = findClosingBracket(cap[2], "()");
        if (lastParenIndex > -1) {
          const start = cap[0].indexOf("!") === 0 ? 5 : 4;
          const linkLen = start + cap[1].length + lastParenIndex;
          cap[2] = cap[2].substring(0, lastParenIndex);
          cap[0] = cap[0].substring(0, linkLen).trim();
          cap[3] = "";
        }
      }
      let href = cap[2];
      let title = "";
      if (this.options.pedantic) {
        const link2 = this.rules.other.pedanticHrefTitle.exec(href);
        if (link2) {
          href = link2[1];
          title = link2[3];
        }
      } else {
        title = cap[3] ? cap[3].slice(1, -1) : "";
      }
      href = href.trim();
      if (this.rules.other.startAngleBracket.test(href)) {
        if (this.options.pedantic && !this.rules.other.endAngleBracket.test(trimmedUrl)) {
          href = href.slice(1);
        } else {
          href = href.slice(1, -1);
        }
      }
      return outputLink(cap, {
        href: href ? href.replace(this.rules.inline.anyPunctuation, "$1") : href,
        title: title ? title.replace(this.rules.inline.anyPunctuation, "$1") : title
      }, cap[0], this.lexer, this.rules);
    }
  }
  reflink(src, links) {
    let cap;
    if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
      const linkString = (cap[2] || cap[1]).replace(this.rules.other.multipleSpaceGlobal, " ");
      const link2 = links[linkString.toLowerCase()];
      if (!link2) {
        const text = cap[0].charAt(0);
        return {
          type: "text",
          raw: text,
          text
        };
      }
      return outputLink(cap, link2, cap[0], this.lexer, this.rules);
    }
  }
  emStrong(src, maskedSrc, prevChar = "") {
    let match = this.rules.inline.emStrongLDelim.exec(src);
    if (!match)
      return;
    if (match[3] && prevChar.match(this.rules.other.unicodeAlphaNumeric))
      return;
    const nextChar = match[1] || match[2] || "";
    if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
      const lLength = [...match[0]].length - 1;
      let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
      const endReg = match[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
      endReg.lastIndex = 0;
      maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
      while ((match = endReg.exec(maskedSrc)) != null) {
        rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
        if (!rDelim)
          continue;
        rLength = [...rDelim].length;
        if (match[3] || match[4]) {
          delimTotal += rLength;
          continue;
        } else if (match[5] || match[6]) {
          if (lLength % 3 && !((lLength + rLength) % 3)) {
            midDelimTotal += rLength;
            continue;
          }
        }
        delimTotal -= rLength;
        if (delimTotal > 0)
          continue;
        rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
        const lastCharLength = [...match[0]][0].length;
        const raw = src.slice(0, lLength + match.index + lastCharLength + rLength);
        if (Math.min(lLength, rLength) % 2) {
          const text2 = raw.slice(1, -1);
          return {
            type: "em",
            raw,
            text: text2,
            tokens: this.lexer.inlineTokens(text2)
          };
        }
        const text = raw.slice(2, -2);
        return {
          type: "strong",
          raw,
          text,
          tokens: this.lexer.inlineTokens(text)
        };
      }
    }
  }
  codespan(src) {
    const cap = this.rules.inline.code.exec(src);
    if (cap) {
      let text = cap[2].replace(this.rules.other.newLineCharGlobal, " ");
      const hasNonSpaceChars = this.rules.other.nonSpaceChar.test(text);
      const hasSpaceCharsOnBothEnds = this.rules.other.startingSpaceChar.test(text) && this.rules.other.endingSpaceChar.test(text);
      if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) {
        text = text.substring(1, text.length - 1);
      }
      return {
        type: "codespan",
        raw: cap[0],
        text
      };
    }
  }
  br(src) {
    const cap = this.rules.inline.br.exec(src);
    if (cap) {
      return {
        type: "br",
        raw: cap[0]
      };
    }
  }
  del(src) {
    const cap = this.rules.inline.del.exec(src);
    if (cap) {
      return {
        type: "del",
        raw: cap[0],
        text: cap[2],
        tokens: this.lexer.inlineTokens(cap[2])
      };
    }
  }
  autolink(src) {
    const cap = this.rules.inline.autolink.exec(src);
    if (cap) {
      let text, href;
      if (cap[2] === "@") {
        text = cap[1];
        href = "mailto:" + text;
      } else {
        text = cap[1];
        href = text;
      }
      return {
        type: "link",
        raw: cap[0],
        text,
        href,
        tokens: [
          {
            type: "text",
            raw: text,
            text
          }
        ]
      };
    }
  }
  url(src) {
    let cap;
    if (cap = this.rules.inline.url.exec(src)) {
      let text, href;
      if (cap[2] === "@") {
        text = cap[0];
        href = "mailto:" + text;
      } else {
        let prevCapZero;
        do {
          prevCapZero = cap[0];
          cap[0] = this.rules.inline._backpedal.exec(cap[0])?.[0] ?? "";
        } while (prevCapZero !== cap[0]);
        text = cap[0];
        if (cap[1] === "www.") {
          href = "http://" + cap[0];
        } else {
          href = cap[0];
        }
      }
      return {
        type: "link",
        raw: cap[0],
        text,
        href,
        tokens: [
          {
            type: "text",
            raw: text,
            text
          }
        ]
      };
    }
  }
  inlineText(src) {
    const cap = this.rules.inline.text.exec(src);
    if (cap) {
      const escaped = this.lexer.state.inRawBlock;
      return {
        type: "text",
        raw: cap[0],
        text: cap[0],
        escaped
      };
    }
  }
};
var _Lexer = class {
  tokens;
  options;
  state;
  tokenizer;
  inlineQueue;
  constructor(options2) {
    this.tokens = [];
    this.tokens.links = /* @__PURE__ */ Object.create(null);
    this.options = options2 || _defaults;
    this.options.tokenizer = this.options.tokenizer || new _Tokenizer();
    this.tokenizer = this.options.tokenizer;
    this.tokenizer.options = this.options;
    this.tokenizer.lexer = this;
    this.inlineQueue = [];
    this.state = {
      inLink: false,
      inRawBlock: false,
      top: true
    };
    const rules = {
      other,
      block: block.normal,
      inline: inline.normal
    };
    if (this.options.pedantic) {
      rules.block = block.pedantic;
      rules.inline = inline.pedantic;
    } else if (this.options.gfm) {
      rules.block = block.gfm;
      if (this.options.breaks) {
        rules.inline = inline.breaks;
      } else {
        rules.inline = inline.gfm;
      }
    }
    this.tokenizer.rules = rules;
  }
  /**
   * Expose Rules
   */
  static get rules() {
    return {
      block,
      inline
    };
  }
  /**
   * Static Lex Method
   */
  static lex(src, options2) {
    const lexer2 = new _Lexer(options2);
    return lexer2.lex(src);
  }
  /**
   * Static Lex Inline Method
   */
  static lexInline(src, options2) {
    const lexer2 = new _Lexer(options2);
    return lexer2.inlineTokens(src);
  }
  /**
   * Preprocessing
   */
  lex(src) {
    src = src.replace(other.carriageReturn, "\n");
    this.blockTokens(src, this.tokens);
    for (let i = 0; i < this.inlineQueue.length; i++) {
      const next = this.inlineQueue[i];
      this.inlineTokens(next.src, next.tokens);
    }
    this.inlineQueue = [];
    return this.tokens;
  }
  blockTokens(src, tokens = [], lastParagraphClipped = false) {
    if (this.options.pedantic) {
      src = src.replace(other.tabCharGlobal, "    ").replace(other.spaceLine, "");
    }
    while (src) {
      let token;
      if (this.options.extensions?.block?.some((extTokenizer) => {
        if (token = extTokenizer.call({ lexer: this }, src, tokens)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return true;
        }
        return false;
      })) {
        continue;
      }
      if (token = this.tokenizer.space(src)) {
        src = src.substring(token.raw.length);
        const lastToken = tokens.at(-1);
        if (token.raw.length === 1 && lastToken !== void 0) {
          lastToken.raw += "\n";
        } else {
          tokens.push(token);
        }
        continue;
      }
      if (token = this.tokenizer.code(src)) {
        src = src.substring(token.raw.length);
        const lastToken = tokens.at(-1);
        if (lastToken?.type === "paragraph" || lastToken?.type === "text") {
          lastToken.raw += "\n" + token.raw;
          lastToken.text += "\n" + token.text;
          this.inlineQueue.at(-1).src = lastToken.text;
        } else {
          tokens.push(token);
        }
        continue;
      }
      if (token = this.tokenizer.fences(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.heading(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.hr(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.blockquote(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.list(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.html(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.def(src)) {
        src = src.substring(token.raw.length);
        const lastToken = tokens.at(-1);
        if (lastToken?.type === "paragraph" || lastToken?.type === "text") {
          lastToken.raw += "\n" + token.raw;
          lastToken.text += "\n" + token.raw;
          this.inlineQueue.at(-1).src = lastToken.text;
        } else if (!this.tokens.links[token.tag]) {
          this.tokens.links[token.tag] = {
            href: token.href,
            title: token.title
          };
        }
        continue;
      }
      if (token = this.tokenizer.table(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.lheading(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      let cutSrc = src;
      if (this.options.extensions?.startBlock) {
        let startIndex = Infinity;
        const tempSrc = src.slice(1);
        let tempStart;
        this.options.extensions.startBlock.forEach((getStartIndex) => {
          tempStart = getStartIndex.call({ lexer: this }, tempSrc);
          if (typeof tempStart === "number" && tempStart >= 0) {
            startIndex = Math.min(startIndex, tempStart);
          }
        });
        if (startIndex < Infinity && startIndex >= 0) {
          cutSrc = src.substring(0, startIndex + 1);
        }
      }
      if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
        const lastToken = tokens.at(-1);
        if (lastParagraphClipped && lastToken?.type === "paragraph") {
          lastToken.raw += "\n" + token.raw;
          lastToken.text += "\n" + token.text;
          this.inlineQueue.pop();
          this.inlineQueue.at(-1).src = lastToken.text;
        } else {
          tokens.push(token);
        }
        lastParagraphClipped = cutSrc.length !== src.length;
        src = src.substring(token.raw.length);
        continue;
      }
      if (token = this.tokenizer.text(src)) {
        src = src.substring(token.raw.length);
        const lastToken = tokens.at(-1);
        if (lastToken?.type === "text") {
          lastToken.raw += "\n" + token.raw;
          lastToken.text += "\n" + token.text;
          this.inlineQueue.pop();
          this.inlineQueue.at(-1).src = lastToken.text;
        } else {
          tokens.push(token);
        }
        continue;
      }
      if (src) {
        const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
        if (this.options.silent) {
          console.error(errMsg);
          break;
        } else {
          throw new Error(errMsg);
        }
      }
    }
    this.state.top = true;
    return tokens;
  }
  inline(src, tokens = []) {
    this.inlineQueue.push({ src, tokens });
    return tokens;
  }
  /**
   * Lexing/Compiling
   */
  inlineTokens(src, tokens = []) {
    let maskedSrc = src;
    let match = null;
    if (this.tokens.links) {
      const links = Object.keys(this.tokens.links);
      if (links.length > 0) {
        while ((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null) {
          if (links.includes(match[0].slice(match[0].lastIndexOf("[") + 1, -1))) {
            maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
          }
        }
      }
    }
    while ((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null) {
      maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
    }
    while ((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null) {
      maskedSrc = maskedSrc.slice(0, match.index) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
    }
    let keepPrevChar = false;
    let prevChar = "";
    while (src) {
      if (!keepPrevChar) {
        prevChar = "";
      }
      keepPrevChar = false;
      let token;
      if (this.options.extensions?.inline?.some((extTokenizer) => {
        if (token = extTokenizer.call({ lexer: this }, src, tokens)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return true;
        }
        return false;
      })) {
        continue;
      }
      if (token = this.tokenizer.escape(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.tag(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.link(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.reflink(src, this.tokens.links)) {
        src = src.substring(token.raw.length);
        const lastToken = tokens.at(-1);
        if (token.type === "text" && lastToken?.type === "text") {
          lastToken.raw += token.raw;
          lastToken.text += token.text;
        } else {
          tokens.push(token);
        }
        continue;
      }
      if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.codespan(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.br(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.del(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.autolink(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (!this.state.inLink && (token = this.tokenizer.url(src))) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      let cutSrc = src;
      if (this.options.extensions?.startInline) {
        let startIndex = Infinity;
        const tempSrc = src.slice(1);
        let tempStart;
        this.options.extensions.startInline.forEach((getStartIndex) => {
          tempStart = getStartIndex.call({ lexer: this }, tempSrc);
          if (typeof tempStart === "number" && tempStart >= 0) {
            startIndex = Math.min(startIndex, tempStart);
          }
        });
        if (startIndex < Infinity && startIndex >= 0) {
          cutSrc = src.substring(0, startIndex + 1);
        }
      }
      if (token = this.tokenizer.inlineText(cutSrc)) {
        src = src.substring(token.raw.length);
        if (token.raw.slice(-1) !== "_") {
          prevChar = token.raw.slice(-1);
        }
        keepPrevChar = true;
        const lastToken = tokens.at(-1);
        if (lastToken?.type === "text") {
          lastToken.raw += token.raw;
          lastToken.text += token.text;
        } else {
          tokens.push(token);
        }
        continue;
      }
      if (src) {
        const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
        if (this.options.silent) {
          console.error(errMsg);
          break;
        } else {
          throw new Error(errMsg);
        }
      }
    }
    return tokens;
  }
};
var _Renderer = class {
  options;
  parser;
  // set by the parser
  constructor(options2) {
    this.options = options2 || _defaults;
  }
  space(token) {
    return "";
  }
  code({ text, lang, escaped }) {
    const langString = (lang || "").match(other.notSpaceStart)?.[0];
    const code = text.replace(other.endingNewline, "") + "\n";
    if (!langString) {
      return "<pre><code>" + (escaped ? code : escape(code, true)) + "</code></pre>\n";
    }
    return '<pre><code class="language-' + escape(langString) + '">' + (escaped ? code : escape(code, true)) + "</code></pre>\n";
  }
  blockquote({ tokens }) {
    const body = this.parser.parse(tokens);
    return `<blockquote>
${body}</blockquote>
`;
  }
  html({ text }) {
    return text;
  }
  heading({ tokens, depth }) {
    return `<h${depth}>${this.parser.parseInline(tokens)}</h${depth}>
`;
  }
  hr(token) {
    return "<hr>\n";
  }
  list(token) {
    const ordered = token.ordered;
    const start = token.start;
    let body = "";
    for (let j = 0; j < token.items.length; j++) {
      const item = token.items[j];
      body += this.listitem(item);
    }
    const type = ordered ? "ol" : "ul";
    const startAttr = ordered && start !== 1 ? ' start="' + start + '"' : "";
    return "<" + type + startAttr + ">\n" + body + "</" + type + ">\n";
  }
  listitem(item) {
    let itemBody = "";
    if (item.task) {
      const checkbox = this.checkbox({ checked: !!item.checked });
      if (item.loose) {
        if (item.tokens[0]?.type === "paragraph") {
          item.tokens[0].text = checkbox + " " + item.tokens[0].text;
          if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") {
            item.tokens[0].tokens[0].text = checkbox + " " + escape(item.tokens[0].tokens[0].text);
            item.tokens[0].tokens[0].escaped = true;
          }
        } else {
          item.tokens.unshift({
            type: "text",
            raw: checkbox + " ",
            text: checkbox + " ",
            escaped: true
          });
        }
      } else {
        itemBody += checkbox + " ";
      }
    }
    itemBody += this.parser.parse(item.tokens, !!item.loose);
    return `<li>${itemBody}</li>
`;
  }
  checkbox({ checked }) {
    return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
  }
  paragraph({ tokens }) {
    return `<p>${this.parser.parseInline(tokens)}</p>
`;
  }
  table(token) {
    let header = "";
    let cell = "";
    for (let j = 0; j < token.header.length; j++) {
      cell += this.tablecell(token.header[j]);
    }
    header += this.tablerow({ text: cell });
    let body = "";
    for (let j = 0; j < token.rows.length; j++) {
      const row = token.rows[j];
      cell = "";
      for (let k = 0; k < row.length; k++) {
        cell += this.tablecell(row[k]);
      }
      body += this.tablerow({ text: cell });
    }
    if (body)
      body = `<tbody>${body}</tbody>`;
    return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
  }
  tablerow({ text }) {
    return `<tr>
${text}</tr>
`;
  }
  tablecell(token) {
    const content = this.parser.parseInline(token.tokens);
    const type = token.header ? "th" : "td";
    const tag2 = token.align ? `<${type} align="${token.align}">` : `<${type}>`;
    return tag2 + content + `</${type}>
`;
  }
  /**
   * span level renderer
   */
  strong({ tokens }) {
    return `<strong>${this.parser.parseInline(tokens)}</strong>`;
  }
  em({ tokens }) {
    return `<em>${this.parser.parseInline(tokens)}</em>`;
  }
  codespan({ text }) {
    return `<code>${escape(text, true)}</code>`;
  }
  br(token) {
    return "<br>";
  }
  del({ tokens }) {
    return `<del>${this.parser.parseInline(tokens)}</del>`;
  }
  link({ href, title, tokens }) {
    const text = this.parser.parseInline(tokens);
    const cleanHref = cleanUrl(href);
    if (cleanHref === null) {
      return text;
    }
    href = cleanHref;
    let out = '<a href="' + href + '"';
    if (title) {
      out += ' title="' + escape(title) + '"';
    }
    out += ">" + text + "</a>";
    return out;
  }
  image({ href, title, text }) {
    const cleanHref = cleanUrl(href);
    if (cleanHref === null) {
      return escape(text);
    }
    href = cleanHref;
    let out = `<img src="${href}" alt="${text}"`;
    if (title) {
      out += ` title="${escape(title)}"`;
    }
    out += ">";
    return out;
  }
  text(token) {
    return "tokens" in token && token.tokens ? this.parser.parseInline(token.tokens) : "escaped" in token && token.escaped ? token.text : escape(token.text);
  }
};
var _TextRenderer = class {
  // no need for block level renderers
  strong({ text }) {
    return text;
  }
  em({ text }) {
    return text;
  }
  codespan({ text }) {
    return text;
  }
  del({ text }) {
    return text;
  }
  html({ text }) {
    return text;
  }
  text({ text }) {
    return text;
  }
  link({ text }) {
    return "" + text;
  }
  image({ text }) {
    return "" + text;
  }
  br() {
    return "";
  }
};
var _Parser = class {
  options;
  renderer;
  textRenderer;
  constructor(options2) {
    this.options = options2 || _defaults;
    this.options.renderer = this.options.renderer || new _Renderer();
    this.renderer = this.options.renderer;
    this.renderer.options = this.options;
    this.renderer.parser = this;
    this.textRenderer = new _TextRenderer();
  }
  /**
   * Static Parse Method
   */
  static parse(tokens, options2) {
    const parser2 = new _Parser(options2);
    return parser2.parse(tokens);
  }
  /**
   * Static Parse Inline Method
   */
  static parseInline(tokens, options2) {
    const parser2 = new _Parser(options2);
    return parser2.parseInline(tokens);
  }
  /**
   * Parse Loop
   */
  parse(tokens, top = true) {
    let out = "";
    for (let i = 0; i < tokens.length; i++) {
      const anyToken = tokens[i];
      if (this.options.extensions?.renderers?.[anyToken.type]) {
        const genericToken = anyToken;
        const ret = this.options.extensions.renderers[genericToken.type].call({ parser: this }, genericToken);
        if (ret !== false || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(genericToken.type)) {
          out += ret || "";
          continue;
        }
      }
      const token = anyToken;
      switch (token.type) {
        case "space": {
          out += this.renderer.space(token);
          continue;
        }
        case "hr": {
          out += this.renderer.hr(token);
          continue;
        }
        case "heading": {
          out += this.renderer.heading(token);
          continue;
        }
        case "code": {
          out += this.renderer.code(token);
          continue;
        }
        case "table": {
          out += this.renderer.table(token);
          continue;
        }
        case "blockquote": {
          out += this.renderer.blockquote(token);
          continue;
        }
        case "list": {
          out += this.renderer.list(token);
          continue;
        }
        case "html": {
          out += this.renderer.html(token);
          continue;
        }
        case "paragraph": {
          out += this.renderer.paragraph(token);
          continue;
        }
        case "text": {
          let textToken = token;
          let body = this.renderer.text(textToken);
          while (i + 1 < tokens.length && tokens[i + 1].type === "text") {
            textToken = tokens[++i];
            body += "\n" + this.renderer.text(textToken);
          }
          if (top) {
            out += this.renderer.paragraph({
              type: "paragraph",
              raw: body,
              text: body,
              tokens: [{ type: "text", raw: body, text: body, escaped: true }]
            });
          } else {
            out += body;
          }
          continue;
        }
        default: {
          const errMsg = 'Token with "' + token.type + '" type was not found.';
          if (this.options.silent) {
            console.error(errMsg);
            return "";
          } else {
            throw new Error(errMsg);
          }
        }
      }
    }
    return out;
  }
  /**
   * Parse Inline Tokens
   */
  parseInline(tokens, renderer = this.renderer) {
    let out = "";
    for (let i = 0; i < tokens.length; i++) {
      const anyToken = tokens[i];
      if (this.options.extensions?.renderers?.[anyToken.type]) {
        const ret = this.options.extensions.renderers[anyToken.type].call({ parser: this }, anyToken);
        if (ret !== false || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(anyToken.type)) {
          out += ret || "";
          continue;
        }
      }
      const token = anyToken;
      switch (token.type) {
        case "escape": {
          out += renderer.text(token);
          break;
        }
        case "html": {
          out += renderer.html(token);
          break;
        }
        case "link": {
          out += renderer.link(token);
          break;
        }
        case "image": {
          out += renderer.image(token);
          break;
        }
        case "strong": {
          out += renderer.strong(token);
          break;
        }
        case "em": {
          out += renderer.em(token);
          break;
        }
        case "codespan": {
          out += renderer.codespan(token);
          break;
        }
        case "br": {
          out += renderer.br(token);
          break;
        }
        case "del": {
          out += renderer.del(token);
          break;
        }
        case "text": {
          out += renderer.text(token);
          break;
        }
        default: {
          const errMsg = 'Token with "' + token.type + '" type was not found.';
          if (this.options.silent) {
            console.error(errMsg);
            return "";
          } else {
            throw new Error(errMsg);
          }
        }
      }
    }
    return out;
  }
};
var _Hooks = class {
  options;
  block;
  constructor(options2) {
    this.options = options2 || _defaults;
  }
  /**
   * Process markdown before marked
   */
  preprocess(markdown) {
    return markdown;
  }
  /**
   * Process HTML after marked is finished
   */
  postprocess(html2) {
    return html2;
  }
  /**
   * Process all tokens before walk tokens
   */
  processAllTokens(tokens) {
    return tokens;
  }
  /**
   * Provide function to tokenize markdown
   */
  provideLexer() {
    return this.block ? _Lexer.lex : _Lexer.lexInline;
  }
  /**
   * Provide function to parse tokens
   */
  provideParser() {
    return this.block ? _Parser.parse : _Parser.parseInline;
  }
};
__publicField(_Hooks, "passThroughHooks", /* @__PURE__ */ new Set([
  "preprocess",
  "postprocess",
  "processAllTokens"
]));
var Marked = class {
  defaults = _getDefaults();
  options = this.setOptions;
  parse = this.parseMarkdown(true);
  parseInline = this.parseMarkdown(false);
  Parser = _Parser;
  Renderer = _Renderer;
  TextRenderer = _TextRenderer;
  Lexer = _Lexer;
  Tokenizer = _Tokenizer;
  Hooks = _Hooks;
  constructor(...args) {
    this.use(...args);
  }
  /**
   * Run callback for every token
   */
  walkTokens(tokens, callback) {
    let values = [];
    for (const token of tokens) {
      values = values.concat(callback.call(this, token));
      switch (token.type) {
        case "table": {
          const tableToken = token;
          for (const cell of tableToken.header) {
            values = values.concat(this.walkTokens(cell.tokens, callback));
          }
          for (const row of tableToken.rows) {
            for (const cell of row) {
              values = values.concat(this.walkTokens(cell.tokens, callback));
            }
          }
          break;
        }
        case "list": {
          const listToken = token;
          values = values.concat(this.walkTokens(listToken.items, callback));
          break;
        }
        default: {
          const genericToken = token;
          if (this.defaults.extensions?.childTokens?.[genericToken.type]) {
            this.defaults.extensions.childTokens[genericToken.type].forEach((childTokens) => {
              const tokens2 = genericToken[childTokens].flat(Infinity);
              values = values.concat(this.walkTokens(tokens2, callback));
            });
          } else if (genericToken.tokens) {
            values = values.concat(this.walkTokens(genericToken.tokens, callback));
          }
        }
      }
    }
    return values;
  }
  use(...args) {
    const extensions = this.defaults.extensions || { renderers: {}, childTokens: {} };
    args.forEach((pack) => {
      const opts = { ...pack };
      opts.async = this.defaults.async || opts.async || false;
      if (pack.extensions) {
        pack.extensions.forEach((ext) => {
          if (!ext.name) {
            throw new Error("extension name required");
          }
          if ("renderer" in ext) {
            const prevRenderer = extensions.renderers[ext.name];
            if (prevRenderer) {
              extensions.renderers[ext.name] = function(...args2) {
                let ret = ext.renderer.apply(this, args2);
                if (ret === false) {
                  ret = prevRenderer.apply(this, args2);
                }
                return ret;
              };
            } else {
              extensions.renderers[ext.name] = ext.renderer;
            }
          }
          if ("tokenizer" in ext) {
            if (!ext.level || ext.level !== "block" && ext.level !== "inline") {
              throw new Error("extension level must be 'block' or 'inline'");
            }
            const extLevel = extensions[ext.level];
            if (extLevel) {
              extLevel.unshift(ext.tokenizer);
            } else {
              extensions[ext.level] = [ext.tokenizer];
            }
            if (ext.start) {
              if (ext.level === "block") {
                if (extensions.startBlock) {
                  extensions.startBlock.push(ext.start);
                } else {
                  extensions.startBlock = [ext.start];
                }
              } else if (ext.level === "inline") {
                if (extensions.startInline) {
                  extensions.startInline.push(ext.start);
                } else {
                  extensions.startInline = [ext.start];
                }
              }
            }
          }
          if ("childTokens" in ext && ext.childTokens) {
            extensions.childTokens[ext.name] = ext.childTokens;
          }
        });
        opts.extensions = extensions;
      }
      if (pack.renderer) {
        const renderer = this.defaults.renderer || new _Renderer(this.defaults);
        for (const prop in pack.renderer) {
          if (!(prop in renderer)) {
            throw new Error(`renderer '${prop}' does not exist`);
          }
          if (["options", "parser"].includes(prop)) {
            continue;
          }
          const rendererProp = prop;
          const rendererFunc = pack.renderer[rendererProp];
          const prevRenderer = renderer[rendererProp];
          renderer[rendererProp] = (...args2) => {
            let ret = rendererFunc.apply(renderer, args2);
            if (ret === false) {
              ret = prevRenderer.apply(renderer, args2);
            }
            return ret || "";
          };
        }
        opts.renderer = renderer;
      }
      if (pack.tokenizer) {
        const tokenizer = this.defaults.tokenizer || new _Tokenizer(this.defaults);
        for (const prop in pack.tokenizer) {
          if (!(prop in tokenizer)) {
            throw new Error(`tokenizer '${prop}' does not exist`);
          }
          if (["options", "rules", "lexer"].includes(prop)) {
            continue;
          }
          const tokenizerProp = prop;
          const tokenizerFunc = pack.tokenizer[tokenizerProp];
          const prevTokenizer = tokenizer[tokenizerProp];
          tokenizer[tokenizerProp] = (...args2) => {
            let ret = tokenizerFunc.apply(tokenizer, args2);
            if (ret === false) {
              ret = prevTokenizer.apply(tokenizer, args2);
            }
            return ret;
          };
        }
        opts.tokenizer = tokenizer;
      }
      if (pack.hooks) {
        const hooks = this.defaults.hooks || new _Hooks();
        for (const prop in pack.hooks) {
          if (!(prop in hooks)) {
            throw new Error(`hook '${prop}' does not exist`);
          }
          if (["options", "block"].includes(prop)) {
            continue;
          }
          const hooksProp = prop;
          const hooksFunc = pack.hooks[hooksProp];
          const prevHook = hooks[hooksProp];
          if (_Hooks.passThroughHooks.has(prop)) {
            hooks[hooksProp] = (arg) => {
              if (this.defaults.async) {
                return Promise.resolve(hooksFunc.call(hooks, arg)).then((ret2) => {
                  return prevHook.call(hooks, ret2);
                });
              }
              const ret = hooksFunc.call(hooks, arg);
              return prevHook.call(hooks, ret);
            };
          } else {
            hooks[hooksProp] = (...args2) => {
              let ret = hooksFunc.apply(hooks, args2);
              if (ret === false) {
                ret = prevHook.apply(hooks, args2);
              }
              return ret;
            };
          }
        }
        opts.hooks = hooks;
      }
      if (pack.walkTokens) {
        const walkTokens2 = this.defaults.walkTokens;
        const packWalktokens = pack.walkTokens;
        opts.walkTokens = function(token) {
          let values = [];
          values.push(packWalktokens.call(this, token));
          if (walkTokens2) {
            values = values.concat(walkTokens2.call(this, token));
          }
          return values;
        };
      }
      this.defaults = { ...this.defaults, ...opts };
    });
    return this;
  }
  setOptions(opt) {
    this.defaults = { ...this.defaults, ...opt };
    return this;
  }
  lexer(src, options2) {
    return _Lexer.lex(src, options2 ?? this.defaults);
  }
  parser(tokens, options2) {
    return _Parser.parse(tokens, options2 ?? this.defaults);
  }
  parseMarkdown(blockType) {
    const parse = (src, options2) => {
      const origOpt = { ...options2 };
      const opt = { ...this.defaults, ...origOpt };
      const throwError = this.onError(!!opt.silent, !!opt.async);
      if (this.defaults.async === true && origOpt.async === false) {
        return throwError(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
      }
      if (typeof src === "undefined" || src === null) {
        return throwError(new Error("marked(): input parameter is undefined or null"));
      }
      if (typeof src !== "string") {
        return throwError(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected"));
      }
      if (opt.hooks) {
        opt.hooks.options = opt;
        opt.hooks.block = blockType;
      }
      const lexer2 = opt.hooks ? opt.hooks.provideLexer() : blockType ? _Lexer.lex : _Lexer.lexInline;
      const parser2 = opt.hooks ? opt.hooks.provideParser() : blockType ? _Parser.parse : _Parser.parseInline;
      if (opt.async) {
        return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then((src2) => lexer2(src2, opt)).then((tokens) => opt.hooks ? opt.hooks.processAllTokens(tokens) : tokens).then((tokens) => opt.walkTokens ? Promise.all(this.walkTokens(tokens, opt.walkTokens)).then(() => tokens) : tokens).then((tokens) => parser2(tokens, opt)).then((html2) => opt.hooks ? opt.hooks.postprocess(html2) : html2).catch(throwError);
      }
      try {
        if (opt.hooks) {
          src = opt.hooks.preprocess(src);
        }
        let tokens = lexer2(src, opt);
        if (opt.hooks) {
          tokens = opt.hooks.processAllTokens(tokens);
        }
        if (opt.walkTokens) {
          this.walkTokens(tokens, opt.walkTokens);
        }
        let html2 = parser2(tokens, opt);
        if (opt.hooks) {
          html2 = opt.hooks.postprocess(html2);
        }
        return html2;
      } catch (e) {
        return throwError(e);
      }
    };
    return parse;
  }
  onError(silent, async) {
    return (e) => {
      e.message += "\nPlease report this to https://github.com/markedjs/marked.";
      if (silent) {
        const msg = "<p>An error occurred:</p><pre>" + escape(e.message + "", true) + "</pre>";
        if (async) {
          return Promise.resolve(msg);
        }
        return msg;
      }
      if (async) {
        return Promise.reject(e);
      }
      throw e;
    };
  }
};
var markedInstance = new Marked();
function marked(src, opt) {
  return markedInstance.parse(src, opt);
}
marked.options = marked.setOptions = function(options2) {
  markedInstance.setOptions(options2);
  marked.defaults = markedInstance.defaults;
  changeDefaults(marked.defaults);
  return marked;
};
marked.getDefaults = _getDefaults;
marked.defaults = _defaults;
marked.use = function(...args) {
  markedInstance.use(...args);
  marked.defaults = markedInstance.defaults;
  changeDefaults(marked.defaults);
  return marked;
};
marked.walkTokens = function(tokens, callback) {
  return markedInstance.walkTokens(tokens, callback);
};
marked.parseInline = markedInstance.parseInline;
marked.Parser = _Parser;
marked.parser = _Parser.parse;
marked.Renderer = _Renderer;
marked.TextRenderer = _TextRenderer;
marked.Lexer = _Lexer;
marked.lexer = _Lexer.lex;
marked.Tokenizer = _Tokenizer;
marked.Hooks = _Hooks;
marked.parse = marked;
var options = marked.options;
var setOptions = marked.setOptions;
var use = marked.use;
var walkTokens = marked.walkTokens;
var parseInline = marked.parseInline;
var parser = _Parser.parse;
var lexer = _Lexer.lex;

// src/sections/shop-chat/shop-chat.ts
var ShopChat = class extends SectionElement {
  constructor() {
    var _a15, _b, _c, _d, _e, _f;
    super();
    this.loading = false;
    this.messageCache = /* @__PURE__ */ new Map();
    const urlParams = new URLSearchParams(window.location.search);
    const chatParam = "enable";
    if (chatParam == "enable") {
      localStorage.setItem("bb-chat-enabled", "true");
    } else if (chatParam == "disable") {
      localStorage.setItem("bb-chat-enabled", "false");
    }
    if (localStorage.getItem("bb-chat-enabled") !== "true") {
      this.remove();
      return;
    }
    this.classList.remove("hidden");
    this.chat = new Chat({
      tool_invocation_add_to_cart: (_a15 = this.toolInvocationAddToCart) == null ? void 0 : _a15.innerText,
      tool_invocation_get_products_by_collection: (_b = this.toolInvocationGetProductsByCollection) == null ? void 0 : _b.innerText,
      tool_invocation_get_products: (_c = this.toolInvocationGetProducts) == null ? void 0 : _c.innerText,
      tool_invocation_get_product_details: (_d = this.toolInvocationGetProductDetails) == null ? void 0 : _d.innerText,
      tool_invocation_go_to_checkout: (_e = this.toolInvocationGoToCheckout) == null ? void 0 : _e.innerText,
      first_message: (_f = this.firstMessage) == null ? void 0 : _f.innerText
    });
  }
  static compareMessages(a, b) {
    if (a.type === "product" && b.type === "product") {
      return a.handle === b.handle && a.variantId === b.variantId && a.imageSrc === b.imageSrc && a.priceInclVat === b.priceInclVat && a.priceExclVat === b.priceExclVat && a.title === b.title;
    } else if (a.type === "text" && b.type === "text") {
      return a.text === b.text;
    }
    return false;
  }
  handleOpenChat() {
    var _a15, _b, _c, _d;
    this.dataset.open = "true";
    this.hideTrustBadge();
    localStorage.setItem("bb-chat-open", "true");
    if (((_a15 = this.chat) == null ? void 0 : _a15.currentChatId) !== "" && ((_b = this.chat) == null ? void 0 : _b.currentChatId) !== null && ((_c = this.chat) == null ? void 0 : _c.currentChatId) !== void 0) {
      this.setActiveChat((_d = this.chat) == null ? void 0 : _d.currentChatId);
    }
    this.updatePreviousChatsButton();
  }
  handleCloseChat() {
    this.dataset.open = "false";
    this.showTrustBadge();
    localStorage.setItem("bb-chat-open", "false");
  }
  hideTrustBadge() {
    document.body.setAttribute("hide-trust-badge", "true");
  }
  showTrustBadge() {
    document.body.removeAttribute("hide-trust-badge");
  }
  isScrollLocked() {
    return document.body.hasAttribute("scroll-lock");
  }
  enableScrollLock() {
    document.body.setAttribute("scroll-lock", "");
  }
  disableScrollLock() {
    document.body.removeAttribute("scroll-lock");
  }
  connectedCallback() {
    var _a15, _b;
    this.classList.remove("hidden");
    this.scrollMessagesToBottom();
    this.messageInput.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        this.handleSendChat();
      }
    });
    (_a15 = this.chat) == null ? void 0 : _a15.onProposals("show", (messages) => {
      this.showProposals(messages);
    });
    (_b = this.chat) == null ? void 0 : _b.onChat("change", (messages) => {
      this.renderChatMessages(messages);
      this.scrollMessagesToBottom();
    });
    if (localStorage.getItem("bb-chat-open") === "true") {
      this.handleOpenChat();
    }
  }
  showProposals(messages) {
    this.proposals.innerHTML = "";
    messages.forEach((message) => {
      this.proposals.insertAdjacentHTML(
        "beforeend",
        /*HTML*/
        `
        <button data-proposal>
          ${message}
        </button>
      `
      );
    });
    this.proposals.querySelectorAll("[data-proposal]").forEach((proposal) => {
      proposal.addEventListener("click", () => {
        this.messageInput.value = proposal.innerText;
        this.handleSendChat();
        this.resetProposals();
      });
    });
    this.messages.style.paddingBottom = this.proposals.offsetHeight + "px";
  }
  resetProposals() {
    this.proposals.innerHTML = "";
    this.messages.style.paddingBottom = "0px";
  }
  updatePreviousChatsButton() {
    if (this.chat != null && this.chat.chatInstancePreviews.length > 0) {
      this.selectButton.classList.remove("hidden");
    } else {
      this.selectButton.classList.add("hidden");
    }
  }
  handleHomeButton() {
    var _a15;
    this.resetProposals();
    (_a15 = this.chat) == null ? void 0 : _a15.exitChat();
    this.dataset.nav = "home";
    this.updatePreviousChatsButton();
  }
  handleStartButton() {
    var _a15;
    const initialProposals = [];
    if (this.initialProposalText1.innerText !== "" && this.initialProposalText1.innerText !== null && this.initialProposalText1.innerText !== void 0) {
      initialProposals.push(this.initialProposalText1.innerText);
    }
    if (this.initialProposalText2.innerText !== "" && this.initialProposalText2.innerText !== null && this.initialProposalText2.innerText !== void 0) {
      initialProposals.push(this.initialProposalText2.innerText);
    }
    if (this.initialProposalText3.innerText !== "" && this.initialProposalText3.innerText !== null && this.initialProposalText3.innerText !== void 0) {
      initialProposals.push(this.initialProposalText3.innerText);
    }
    this.resetProposals();
    (_a15 = this.chat) == null ? void 0 : _a15.startNewChat(initialProposals);
    this.dataset.nav = "chat";
    this.scrollMessagesToBottom();
    const isDesktop = window.matchMedia(`(min-width: 768px)`).matches;
    if (isDesktop) {
      this.messageInput.focus();
    }
  }
  handleSelectButton() {
    this.resetProposals();
    this.dataset.nav = "select";
    this.loadAndUpdateChatList();
  }
  handleSendChat() {
    return __async(this, null, function* () {
      var _a15;
      const messageToSend = this.messageInput.value;
      if (messageToSend === "" || messageToSend === null || messageToSend === void 0)
        return;
      this.proposals.innerHTML = "";
      this.messageInput.value = "";
      this.scrollMessagesToBottom();
      this.setLoading(true);
      const responseMessages = yield (_a15 = this.chat) == null ? void 0 : _a15.handleSendMessage(messageToSend);
      this.scrollMessagesToBottom();
      this.setLoading(false);
    });
  }
  setLoading(loading) {
    return __async(this, null, function* () {
      this.loading = loading;
      this.messageInput.disabled = loading;
      this.sendButton.disabled = loading;
      if (loading === true) {
        yield new Promise(
          () => setTimeout(() => {
            if (this.loading) {
              this.dataset.loading = "true";
            }
          }, 500)
        );
      } else if (loading === false && this.dataset.loading == "true") {
        this.dataset.loading = "false";
      }
    });
  }
  scrollMessagesToBottom() {
    const scrollContainer = this.messages.parentElement;
    if (scrollContainer) {
      scrollContainer.scrollTo({
        top: scrollContainer.scrollHeight,
        behavior: "instant"
      });
    }
  }
  loadAndUpdateChatList() {
    var _a15;
    const chatInstancePreviews = (_a15 = this.chat) == null ? void 0 : _a15.chatInstancePreviews;
    this.updatePreviousChatsButton();
    if (!chatInstancePreviews || chatInstancePreviews.length < 1) {
      this.dataset.nav = "home";
      return;
    }
    this.handleSetChatList(chatInstancePreviews);
  }
  handleSetChatList(instances) {
    this.chatlist.innerHTML = "";
    this.chatlist.insertAdjacentHTML(
      "beforeend",
      instances.map((instance) => {
        return (
          /*HTML*/
          `<div class="group h-14 border-b text-gray-200 border-gray-600 text-left flex justify-start items-center hover:bg-gray-800 w-full">
          <button data-chat-continue-button="${instance.id}" class="pl-[18px] h-14 group-hover:pr-0 pr-[18px] w-full whitespace-nowrap overflow-ellipsis overflow-hidden text-gray-200 font-medium text-sm flex-1">
            ${instance.lastMessage.sender === "assistant" ? "Bernd: " : instance.lastMessage.sender === "user" ? "Du: " : ""}
            ${instance.lastMessage.type == "text" ? instance.lastMessage.text : instance.lastMessage.type == "product" ? instance.lastMessage.title : ""}
          </button>
          <div class="h-14 p-3 aspect-square hidden group-hover:block">
            <button aria-label="Entfernen" data-chat-remove-button="${instance.id}" class="w-full h-full hover:bg-gray-700 flex items-center justify-center rounded-md">
              <svg class="h-5 w-5 pointer-events-none" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2zM7 6v13z"/></svg>
            </button>
          </div>
        </div>
      `
        );
      }).join("")
    );
    this.chatlist.querySelectorAll("[data-chat-continue-button]").forEach((button) => {
      button.addEventListener("click", (evt) => {
        var _a15, _b;
        const id = (_b = (_a15 = evt.target) == null ? void 0 : _a15.dataset) == null ? void 0 : _b.chatContinueButton;
        if (!id)
          return;
        this.setActiveChat(id);
      });
    });
    this.chatlist.querySelectorAll("[data-chat-remove-button]").forEach((button) => {
      button.addEventListener("click", (evt) => {
        var _a15, _b, _c;
        const id = (_b = (_a15 = evt.target) == null ? void 0 : _a15.dataset) == null ? void 0 : _b.chatRemoveButton;
        if (!id)
          return;
        (_c = this.chat) == null ? void 0 : _c.removeChat(id);
        this.loadAndUpdateChatList();
      });
    });
  }
  setActiveChat(id) {
    var _a15;
    this.dataset.nav = "chat";
    (_a15 = this.chat) == null ? void 0 : _a15.loadAndSetCurrentChat(id);
    this.scrollMessagesToBottom();
  }
  renderChatMessages(messages) {
    const messageIdsExistingInView = this.messageIdElements.map((element) => element.dataset.messageId).filter((id) => id != null);
    const messagesNew = messages.filter((message) => !messageIdsExistingInView.includes(message.id));
    const messagesUpdate = messages.filter((message) => messageIdsExistingInView.includes(message.id));
    const messageIdsToRemove = messageIdsExistingInView.filter((id) => !messages.map((message) => message.id).includes(id));
    messageIdsToRemove.forEach((id) => {
      this.removeMessage(id);
    });
    messagesUpdate.forEach((message) => {
      this.updateMessage(message);
    });
    messagesNew.forEach((message) => {
      this.appendMessage(message);
    });
  }
  removeMessage(messageId) {
    var _a15;
    this.messageCache.delete(messageId);
    (_a15 = this.querySelector(`[data-message-id="${messageId}"]`)) == null ? void 0 : _a15.remove();
  }
  appendMessage(message) {
    this.messageCache.set(message.id, message);
    if (message.type === "text") {
      this.appendTextMessage(message);
    } else if (message.type === "product") {
      this.appendProductMessage(message);
    }
  }
  appendTextMessage(message) {
    const html2 = marked.parse(message.text, {
      async: false
    });
    this.messages.insertAdjacentHTML(
      "beforeend",
      /*HTML*/
      `
      <div data-message-wrapper data-message-id="${message.id}" ${message.sender == "user" ? "data-chat-sent" : message.sender == "assistant" ? "data-chat-received" : "data-chat-system"}>
        ${message.sender == "assistant" ? ICON_SVS_HELMET : ""}
        <div data-message data-text-message>
          ${html2}
        </div>
      </div>
    `
    );
  }
  appendProductMessage(message) {
    var _a15, _b, _c, _d;
    this.messages.insertAdjacentHTML(
      "beforeend",
      /*HTML*/
      `
      <div data-message-wrapper data-message-id="${message.id}" ${message.sender == "user" ? "data-chat-sent" : "data-chat-received"}>
      ${message.sender == "assistant" ? ICON_SVS_HELMET : ""}
        <div data-message data-product-message>
          <a data-product-message-link href="/products/${message.handle}${message.variantId ? "?variant=${message.variantId}" : ""}">
            <div>
              <div data-product-message-image-placeholder class="loading-skeleton ${message.imageSrc != null ? "hidden" : ""}"></div>
              <img data-product-message-image src="${message.imageSrc}" class="${message.imageSrc != null ? "" : "hidden"}">
              <div data-product-message-texts>
                <p data-product-message-title class="${message.title != null ? "" : "loading-skeleton"}">${message.title != null ? message.title : "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"}</p>
                <div data-product-message-price-container>
                  <div data-product-message-incl-vat-container>
                    <p data-product-message-price-first class="${message.priceInclVat != null ? "" : "loading-skeleton"}">${message.priceInclVat != null ? `${message.priceVaries ? "ab " : ""}${message.priceInclVat}` : "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"}</p>
                    <p data-product-message-price-second class="${message.priceInclVat != null ? "" : "loading-skeleton"}">${message.priceInclVat != null ? `${(_b = (_a15 = this.exclVatTextElement) == null ? void 0 : _a15.innerText) != null ? _b : "ohne MwSt."} ${message.priceExclVat}` : "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"}</p>
                  </div>
                  <div data-product-message-excl-vat-container>
                    <p data-product-message-price-first class="${message.priceExclVat != null ? "" : "loading-skeleton"}">
                    ${message.priceExclVat != null ? `${message.priceVaries ? "ab " : ""}${message.priceExclVat}` : "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"}
                    </p>
                    <p data-product-message-price-second class="${message.priceInclVat != null ? "" : "loading-skeleton"}">${message.priceInclVat != null ? `${(_d = (_c = this.inclVatTextElement) == null ? void 0 : _c.innerText) != null ? _d : "inkl. MwSt."} ${message.priceInclVat}` : "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"}</p>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    `
    );
  }
  updateMessage(message) {
    const cachedMessage = this.messageCache.get(message.id);
    if (cachedMessage && ShopChat.compareMessages(cachedMessage, message))
      return;
    this.messageCache.set(message.id, message);
    const messageElement = this.querySelector(`[data-message-id="${message.id}"]`);
    if (!messageElement)
      return;
    if (message.type === "text") {
      this.updateTextMessage(message);
    } else if (message.type === "product") {
      this.updateProductMessage(message);
    }
  }
  updateTextMessage(message) {
    const messageElement = this.messages.querySelector(`[data-message-id="${message.id}"]`);
    if (!messageElement)
      return;
    const messageInnerElement = messageElement.querySelector("[data-message]");
    if (!messageInnerElement)
      return;
    const html2 = marked.parse(message.text, {
      async: false
    });
    messageInnerElement.innerHTML = html2;
  }
  updateProductMessage(message) {
    return __async(this, null, function* () {
      var _a15, _b, _c, _d;
      if (message.type !== "product")
        return;
      const messageElement = this.querySelector(`[data-message-id="${message.id}"]`);
      const titleElement = messageElement.querySelector("[data-product-message-title]");
      const imageElement = messageElement.querySelector("[data-product-message-image]");
      const imagePlaceholderElement = messageElement.querySelector("[data-product-message-image-placeholder]");
      const inclVatContainer = messageElement.querySelector("[data-product-message-incl-vat-container]");
      const exclVatContainer = messageElement.querySelector("[data-product-message-excl-vat-container]");
      const inclVatPriceFirstElement = inclVatContainer.querySelector("[data-product-message-price-first]");
      const inclVatPriceSecondElement = inclVatContainer.querySelector("[data-product-message-price-second]");
      const exclVatPriceFirstElement = exclVatContainer.querySelector("[data-product-message-price-first]");
      const exclVatPriceSecondElement = exclVatContainer.querySelector("[data-product-message-price-second]");
      if (message.title != null) {
        titleElement.innerText = message.title;
        titleElement.classList.remove("loading-skeleton");
      }
      if (message.imageSrc != null) {
        imageElement.src = message.imageSrc;
        imageElement.classList.remove("hidden");
        imagePlaceholderElement.classList.add("hidden");
      }
      if (message.priceInclVat != null) {
        inclVatPriceFirstElement.innerText = `${message.priceVaries ? "ab " : ""}${message.priceInclVat}`;
        inclVatPriceSecondElement.innerText = `${(_b = (_a15 = this.exclVatTextElement) == null ? void 0 : _a15.innerText) != null ? _b : "ohne MwSt."} ${message.priceExclVat}`;
        inclVatPriceFirstElement.classList.remove("loading-skeleton");
        inclVatPriceSecondElement.classList.remove("loading-skeleton");
      }
      if (message.priceExclVat != null) {
        exclVatPriceFirstElement.innerText = `${message.priceVaries ? "ab " : ""}${message.priceExclVat}`;
        exclVatPriceSecondElement.innerText = `${(_d = (_c = this.inclVatTextElement) == null ? void 0 : _c.innerText) != null ? _d : "inkl. MwSt."} ${message.priceInclVat}`;
        exclVatPriceFirstElement.classList.remove("loading-skeleton");
        exclVatPriceSecondElement.classList.remove("loading-skeleton");
      }
    });
  }
};
__decorateClass([
  query("[data-message-input]")
], ShopChat.prototype, "messageInput", 2);
__decorateClass([
  query("[data-messages]")
], ShopChat.prototype, "messages", 2);
__decorateClass([
  query("[data-chat-window-select-list]")
], ShopChat.prototype, "chatlist", 2);
__decorateClass([
  query("[data-message-send]")
], ShopChat.prototype, "sendButton", 2);
__decorateClass([
  query("[data-incl-vat-text]")
], ShopChat.prototype, "inclVatTextElement", 2);
__decorateClass([
  query("[data-excl-vat-text]")
], ShopChat.prototype, "exclVatTextElement", 2);
__decorateClass([
  query("[data-tool-invocation-add-to-cart]")
], ShopChat.prototype, "toolInvocationAddToCart", 2);
__decorateClass([
  query("[data-tool-invocation-get-products-by-collection]")
], ShopChat.prototype, "toolInvocationGetProductsByCollection", 2);
__decorateClass([
  query("[data-tool-invocation-get-products]")
], ShopChat.prototype, "toolInvocationGetProducts", 2);
__decorateClass([
  query("[data-tool-invocation-get-product-details]")
], ShopChat.prototype, "toolInvocationGetProductDetails", 2);
__decorateClass([
  query("[data-tool-invocation-go-to-checkout]")
], ShopChat.prototype, "toolInvocationGoToCheckout", 2);
__decorateClass([
  query("[data-first-message]")
], ShopChat.prototype, "firstMessage", 2);
__decorateClass([
  query("[data-initial-proposal-text-1]")
], ShopChat.prototype, "initialProposalText1", 2);
__decorateClass([
  query("[data-initial-proposal-text-2]")
], ShopChat.prototype, "initialProposalText2", 2);
__decorateClass([
  query("[data-initial-proposal-text-3]")
], ShopChat.prototype, "initialProposalText3", 2);
__decorateClass([
  query("[data-proposals]")
], ShopChat.prototype, "proposals", 2);
__decorateClass([
  query("[data-chat-select-button]")
], ShopChat.prototype, "selectButton", 2);
__decorateClass([
  onClick("[data-chat-open-button]")
], ShopChat.prototype, "handleOpenChat", 1);
__decorateClass([
  onClick("[data-chat-close-button]")
], ShopChat.prototype, "handleCloseChat", 1);
__decorateClass([
  onClick("[data-chat-home-button]")
], ShopChat.prototype, "handleHomeButton", 1);
__decorateClass([
  onClick("[data-chat-start-button]")
], ShopChat.prototype, "handleStartButton", 1);
__decorateClass([
  onClick("[data-chat-select-button]")
], ShopChat.prototype, "handleSelectButton", 1);
__decorateClass([
  onClick("[data-message-send]")
], ShopChat.prototype, "handleSendChat", 1);
__decorateClass([
  queryAll("[data-message-id]")
], ShopChat.prototype, "messageIdElements", 2);
ShopChat = __decorateClass([
  defineElement("shop-chat")
], ShopChat);
export {
  ShopChat
};
